export const MPs = [
  {
    name: "Ms Diane Abbott",
    party: "Labour",
    constituency: "Hackney North and Stoke Newington",
    email: "diane.abbott.office@parliament.uk",
    handle: "@HackneyAbbott",
  },
  {
    name: "Debbie Abrahams",
    party: "Labour",
    constituency: "Oldham East and Saddleworth",
    email: "abrahamsd@parliament.uk",
    handle: "@Debbie_abrahams",
  },
  {
    name: "Nigel Adams",
    party: "Conservative",
    constituency: "Selby and Ainsty",
    email: "nigel.adams.mp@parliament.uk",
    handle: "@nadams",
  },
  {
    name: "Bim Afolami",
    party: "Conservative",
    constituency: "Hitchin and Harpenden",
    email: "bim.afolami.mp@parliament.uk",
    handle: "@BimAfolami",
  },
  {
    name: "Adam Afriyie",
    party: "Conservative",
    constituency: "Windsor",
    email: "adam.afriyie.mp@parliament.uk",
    handle: "@AdamAfriyie",
  },
  {
    name: "Nickie Aiken",
    party: "Conservative",
    constituency: "Cities of London and Westminster",
    email: "nickie.aiken.mp@parliament.uk",
    handle: "@twocitiesnickie",
  },
  {
    name: "Peter Aldous",
    party: "Conservative",
    constituency: "Waveney",
    email: "peter.aldous.mp@parliament.uk",
    handle: "@peter_aldous",
  },
  {
    name: "Rushanara Ali",
    party: "Labour",
    constituency: "Bethnal Green and Bow",
    email: "rushanara.ali.mp@parliament.uk",
    handle: "@rushanaraali",
  },
  {
    name: "Tahir Ali",
    party: "Labour",
    constituency: "Birmingham, Hall Green",
    email: "tahir.ali.mp@parliament.uk",
    handle: "@TahirAliMP",
  },
  {
    name: "Lucy Allan",
    party: "Conservative",
    constituency: "Telford",
    email: "lucy.allan.mp@parliament.uk",
    handle: "@lucyallan",
  },
  {
    name: "Dr Rosena Allin-Khan",
    party: "Labour",
    constituency: "Tooting",
    email: "rosena.allinkhan.mp@parliament.uk",
    handle: "@DrRosena",
  },
  {
    name: "Mike Amesbury",
    party: "Labour",
    constituency: "Weaver Vale",
    email: "mike.amesbury.mp@parliament.uk",
    handle: "@MikeAmesburyMP",
  },
  {
    name: "Fleur Anderson",
    party: "Labour",
    constituency: "Putney",
    email: "fleur.anderson.mp@parliament.uk",
    handle: "@PutneyFleur",
  },
  {
    name: "Lee Anderson",
    party: "Conservative",
    constituency: "Ashfield",
    email: "lee.anderson.mp@parliament.uk",
    handle: "@LeeAndersonMP_",
  },
  {
    name: "Stuart Anderson",
    party: "Conservative",
    constituency: "Wolverhampton South West",
    email: "stuart.anderson.mp@parliament.uk",
    handle: "@_AndersonStuart",
  },
  {
    name: "Stuart Andrew",
    party: "Conservative",
    constituency: "Pudsey",
    email: "stuart.andrew.mp@parliament.uk",
    handle: "@StuartAndrew",
  },
  {
    name: "Caroline Ansell",
    party: "Conservative",
    constituency: "Eastbourne",
    email: "caroline.ansell.mp@parliament.uk",
    handle: "@Caroline_Ansell",
  },
  {
    name: "Tonia Antoniazzi",
    party: "Labour",
    constituency: "Gower",
    email: "tonia.antoniazzi.mp@parliament.uk",
    handle: "@ToniaAntoniazzi",
  },
  {
    name: "Edward Argar",
    party: "Conservative",
    constituency: "Charnwood",
    email: "edward.argar.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Jonathan Ashworth",
    party: "Labour (Co-op)",
    constituency: "Leicester South",
    email: "jon.ashworth.mp@parliament.uk",
    handle: "@JonAshworth",
  },
  {
    name: "Sarah Atherton",
    party: "Conservative",
    constituency: "Wrexham",
    email: "sarah.atherton.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Victoria Atkins",
    party: "Conservative",
    constituency: "Louth and Horncastle",
    email: "Victoria@victoriaatkins.org.uk",
    handle: null,
  },
  {
    name: "Gareth Bacon",
    party: "Conservative",
    constituency: "Orpington",
    email: "gareth.bacon.mp@parliament.uk",
    handle: "@GarethBaconMP",
  },
  {
    name: "Mr Richard Bacon",
    party: "Conservative",
    constituency: "South Norfolk",
    email: "richardbaconmp@parliament.uk",
    handle: "@richardbaconmp",
  },
  {
    name: "Kemi Badenoch",
    party: "Conservative",
    constituency: "Saffron Walden",
    email: "kemi.badenoch.mp@parliament.uk",
    handle: "@KemiBadenoch",
  },
  {
    name: "Shaun Bailey",
    party: "Conservative",
    constituency: "West Bromwich West",
    email: "shaun.bailey.mp@parliament.uk",
    handle: "@Shaun4WBW",
  },
  {
    name: "Siobhan Baillie",
    party: "Conservative",
    constituency: "Stroud",
    email: "siobhan.baillie.mp@parliament.uk",
    handle: "@Siobhan_Baillie",
  },
  {
    name: "Duncan Baker",
    party: "Conservative",
    constituency: "North Norfolk",
    email: "duncan@duncanbaker.org.uk",
    handle: "@duncancbaker",
  },
  {
    name: "Mr Steve Baker",
    party: "Conservative",
    constituency: "Wycombe",
    email: "steve.baker.mp@parliament.uk",
    handle: "@SteveBakerHW",
  },
  {
    name: "Harriett Baldwin",
    party: "Conservative",
    constituency: "West Worcestershire",
    email: "harriett.baldwin.mp@parliament.uk",
    handle: "@hbaldwin",
  },
  {
    name: "Steve Barclay",
    party: "Conservative",
    constituency: "North East Cambridgeshire",
    email: "stephen.barclay.mp@parliament.uk",
    handle: "@SteveBarclay",
  },
  {
    name: "Hannah Bardell",
    party: "Scottish National Party",
    constituency: "Livingston",
    email: "hannah.bardell.mp@parliament.uk",
    handle: "@HannahB4LiviMP",
  },
  {
    name: "Paula Barker",
    party: "Labour",
    constituency: "Liverpool, Wavertree",
    email: "paula.barker.mp@parliament.uk",
    handle: "@PaulaBarkerMP",
  },
  {
    name: "Mr John Baron",
    party: "Conservative",
    constituency: "Basildon and Billericay",
    email: "john.baron.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Simon Baynes",
    party: "Conservative",
    constituency: "Clwyd South",
    email: "simon.baynes.mp@parliament.uk",
    handle: "@baynes_simon",
  },
  {
    name: "Margaret Beckett",
    party: "Labour",
    constituency: "Derby South",
    email: "margaret.beckett.mp@parliament.uk",
    handle: null,
  },
  {
    name: "\u00d3rfhlaith Begley",
    party: "Sinn F\u00e9in",
    constituency: "West Tyrone",
    email: "orfhlaith.begley@sinnfein.ie",
    handle: "@OrfhlaithBegley",
  },
  {
    name: "Apsana Begum",
    party: "Labour",
    constituency: "Poplar and Limehouse",
    email: "apsana.begum.mp@parliament.uk",
    handle: "@ApsanaBegumMP",
  },
  {
    name: "Aaron Bell",
    party: "Conservative",
    constituency: "Newcastle-under-Lyme",
    email: "aaron.bell.mp@parliament.uk",
    handle: "@AaronBell4NUL",
  },
  {
    name: "Hilary Benn",
    party: "Labour",
    constituency: "Leeds Central",
    email: "bennh@parliament.uk",
    handle: "@hilarybennmp",
  },
  {
    name: "Scott Benton",
    party: "Conservative",
    constituency: "Blackpool South",
    email: "scott.benton.mp@parliament.uk",
    handle: "@ScottBentonMP",
  },
  {
    name: "Sir Paul Beresford",
    party: "Conservative",
    constituency: "Mole Valley",
    email: "annie.winsbury@parliament.uk",
    handle: null,
  },
  {
    name: "Sir Jake Berry",
    party: "Conservative",
    constituency: "Rossendale and Darwen",
    email: "jake.berry.mp@parliament.uk",
    handle: "@JakeBerry",
  },
  {
    name: "Mr Clive Betts",
    party: "Labour",
    constituency: "Sheffield South East",
    email: "officeofclivebettsmp@parliament.uk",
    handle: null,
  },
  {
    name: "Saqib Bhatti",
    party: "Conservative",
    constituency: "Meriden",
    email: "saqib.bhatti@parliament.uk",
    handle: "@bhatti_saqib",
  },
  {
    name: "Mhairi Black",
    party: "Scottish National Party",
    constituency: "Paisley and Renfrewshire South",
    email: "mhairi.black.mp@parliament.uk",
    handle: "@MhairiBlack",
  },
  {
    name: "Ian Blackford",
    party: "Scottish National Party",
    constituency: "Ross, Skye and Lochaber",
    email: "ian.blackford.mp@parliament.uk",
    handle: "@Ianblackford_MP",
  },
  {
    name: "Bob Blackman",
    party: "Conservative",
    constituency: "Harrow East",
    email: "bob.blackman.mp@parliament.uk",
    handle: "@BobBlackman",
  },
  {
    name: "Kirsty Blackman",
    party: "Scottish National Party",
    constituency: "Aberdeen North",
    email: "kirsty.blackman.mp@parliament.uk",
    handle: "@KirstySNP",
  },
  {
    name: "Olivia Blake",
    party: "Labour",
    constituency: "Sheffield, Hallam",
    email: "olivia.blake.mp@parliament.uk",
    handle: "@_OliviaBlake",
  },
  {
    name: "Paul Blomfield",
    party: "Labour",
    constituency: "Sheffield Central",
    email: "paul.blomfield.mp@parliament.uk",
    handle: "@PaulBlomfieldMP",
  },
  {
    name: "Crispin Blunt",
    party: "Conservative",
    constituency: "Reigate",
    email: "crispinbluntmp@parliament.uk",
    handle: "@CrispinBlunt",
  },
  {
    name: "Gen Kitchen",
    party: "Labour",
    constituency: "Wellingborough",
    email: "bonep@parliament.uk",
    handle: "@Gvkitchen",
  },
  {
    name: "Steven Bonnar",
    party: "Scottish National Party",
    constituency: "Coatbridge, Chryston and Bellshill",
    email: "steven.bonnar.mp@parliament.uk",
    handle: "@StevenBonnarSNP",
  },
  {
    name: "Sir Peter Bottomley",
    party: "Conservative",
    constituency: "Worthing West",
    email: "bottomleyp@parliament.uk",
    handle: "@PBottomleyMP",
  },
  {
    name: "Andrew Bowie",
    party: "Conservative",
    constituency: "West Aberdeenshire and Kincardine",
    email: "andrew.bowie.mp@parliament.uk",
    handle: "@AndrewBowie_MP",
  },
  {
    name: "Ben Bradley",
    party: "Conservative",
    constituency: "Mansfield",
    email: "ben.bradley.mp@parliament.uk",
    handle: "@BBradley_Mans",
  },
  {
    name: "Karen Bradley",
    party: "Conservative",
    constituency: "Staffordshire Moorlands",
    email: "karen.bradley.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mr Ben Bradshaw",
    party: "Labour",
    constituency: "Exeter",
    email: "bradshawb@parliament.uk",
    handle: "@BenPBradshaw",
  },
  {
    name: "Sir Graham Brady",
    party: "Conservative",
    constituency: "Altrincham and Sale West",
    email: "altsale@parliament.uk",
    handle: "@SirGrahamBrady",
  },
  {
    name: "Mickey Brady",
    party: "Sinn F\u00e9in",
    constituency: "Newry and Armagh",
    email: "mickey.brady.mp@parliament.uk",
    handle: "@MickeyBradySF",
  },
  {
    name: "Suella Braverman",
    party: "Conservative",
    constituency: "Fareham",
    email: "suella.braverman.mp@parliament.uk",
    handle: "@SuellaBraverman",
  },
  {
    name: "Kevin Brennan",
    party: "Labour",
    constituency: "Cardiff West",
    email: "brennank@parliament.uk",
    handle: "@KevinBrennanMP",
  },
  {
    name: "Jack Brereton",
    party: "Conservative",
    constituency: "Stoke-on-Trent South",
    email: "jack.brereton.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Andrew Bridgen",
    party: "Independent",
    constituency: "North West Leicestershire",
    email: "andrew.bridgen.mp@parliament.uk",
    handle: "@ABridgen",
  },
  {
    name: "Steve Brine",
    party: "Conservative",
    constituency: "Winchester",
    email: "steve.brine.mp@parliament.uk",
    handle: "@BrineMP",
  },
  {
    name: "Paul Bristow",
    party: "Conservative",
    constituency: "Peterborough",
    email: "paul.bristow.mp@parliament.uk",
    handle: "@paulbristow79",
  },
  {
    name: "Sara Britcliffe",
    party: "Conservative",
    constituency: "Hyndburn",
    email: "sara.britcliffe.mp@parliament.uk",
    handle: "@SarBritcliffeMP",
  },
  {
    name: "Deidre Brock",
    party: "Scottish National Party",
    constituency: "Edinburgh North and Leith",
    email: "deidre.brock.mp@parliament.uk",
    handle: "@DeidreBrock",
  },
  {
    name: "Alan Brown",
    party: "Scottish National Party",
    constituency: "Kilmarnock and Loudoun",
    email: "alan.brown.mp@parliament.uk",
    handle: "@AlanBrownSNP",
  },
  {
    name: "Ms Lyn Brown",
    party: "Labour",
    constituency: "West Ham",
    email: "brownl@parliament.uk",
    handle: "@lynbrownmp",
  },
  {
    name: "Mr Nicholas Brown",
    party: "Independent",
    constituency: "Newcastle upon Tyne East",
    email: "nickbrownmp@parliament.uk",
    handle: null,
  },
  {
    name: "Anthony Browne",
    party: "Conservative",
    constituency: "South Cambridgeshire",
    email: "anthony.browne.mp@parliament.uk",
    handle: "@ab4scambs",
  },
  {
    name: "Fiona Bruce",
    party: "Conservative",
    constituency: "Congleton",
    email: "fiona.bruce.mp@parliament.uk",
    handle: "@UK_FoRBEnvoy",
  },
  {
    name: "Sir Chris Bryant",
    party: "Labour",
    constituency: "Rhondda",
    email: "chris.bryant.mp@parliament.uk",
    handle: "@RhonddaBryant",
  },
  {
    name: "Felicity Buchan",
    party: "Conservative",
    constituency: "Kensington",
    email: "felicity.buchan.mp@parliament.uk",
    handle: "@FelicityBuchan",
  },
  {
    name: "Ms Karen Buck",
    party: "Labour",
    constituency: "Westminster North",
    email: "buckk@parliament.uk",
    handle: "@KarenPBuckMP",
  },
  {
    name: "Sir Robert Buckland",
    party: "Conservative",
    constituency: "South Swindon",
    email: "robert.buckland.mp@parliament.uk",
    handle: "@RobertBuckland",
  },
  {
    name: "Alex Burghart",
    party: "Conservative",
    constituency: "Brentwood and Ongar",
    email: "alex.burghart.mp@parliament.uk",
    handle: "@alexburghart",
  },
  {
    name: "Richard Burgon",
    party: "Labour",
    constituency: "Leeds East",
    email: "richard@richardburgon.com",
    handle: "@RichardBurgon",
  },
  {
    name: "Conor Burns",
    party: "Conservative",
    constituency: "Bournemouth West",
    email: "conor.burns.mp@parliament.uk",
    handle: "@ConorBurnsUK",
  },
  {
    name: "Dawn Butler",
    party: "Labour",
    constituency: "Brent Central",
    email: "dawn.butler.mp@parliament.uk",
    handle: "@DawnButlerBrent",
  },
  {
    name: "Rob Butler",
    party: "Conservative",
    constituency: "Aylesbury",
    email: "rob.butler.mp@parliament.uk",
    handle: "@AylesburyTories",
  },
  {
    name: "Ian Byrne",
    party: "Labour",
    constituency: "Liverpool, West Derby",
    email: "ian.byrne.mp@parliament.uk",
    handle: "@IanByrneMP",
  },
  {
    name: "Liam Byrne",
    party: "Labour",
    constituency: "Birmingham, Hodge Hill",
    email: "byrnel@parliament.uk",
    handle: "@liambyrnemp",
  },
  {
    name: "Ruth Cadbury",
    party: "Labour",
    constituency: "Brentford and Isleworth",
    email: "ruthcadburymp@parliament.uk",
    handle: "@RuthCadbury",
  },
  {
    name: "Alun Cairns",
    party: "Conservative",
    constituency: "Vale of Glamorgan",
    email: "alun.cairns.mp@parliament.uk",
    handle: "@AlunCairns",
  },
  {
    name: "Amy Callaghan",
    party: "Scottish National Party",
    constituency: "East Dunbartonshire",
    email: "amy.callaghan.mp@parliament.uk",
    handle: "@AmyCallaghanSNP",
  },
  {
    name: "Dr Lisa Cameron",
    party: "Scottish National Party",
    constituency: "East Kilbride, Strathaven and Lesmahagow",
    email: "lisa.cameron.mp@parliament.uk",
    handle: "@DrLisaCameronMP",
  },
  {
    name: "Sir Alan Campbell",
    party: "Labour",
    constituency: "Tynemouth",
    email: "alan.campbell.mp@parliament.uk",
    handle: "@alancampbellmp",
  },
  {
    name: "Mr Gregory Campbell",
    party: "Democratic Unionist Party",
    constituency: "East Londonderry",
    email: "aaron.callan@parliament.uk",
    handle: null,
  },
  {
    name: "Dan Carden",
    party: "Labour",
    constituency: "Liverpool, Walton",
    email: "dan.carden.mp@parliament.uk",
    handle: "@DanCardenMP",
  },
  {
    name: "Mr Alistair Carmichael",
    party: "Liberal Democrat",
    constituency: "Orkney and Shetland",
    email: "carmichaela@parliament.uk",
    handle: "@amcarmichaelMP",
  },
  {
    name: "Andy Carter",
    party: "Conservative",
    constituency: "Warrington South",
    email: "andy.carter.mp@parliament.uk",
    handle: "@MrAndy_Carter",
  },
  {
    name: "James Cartlidge",
    party: "Conservative",
    constituency: "South Suffolk",
    email: "james.cartlidge.mp@parliament.uk",
    handle: "@jcartlidgemp",
  },
  {
    name: "Sir William Cash",
    party: "Conservative",
    constituency: "Stone",
    email: "cashw@parliament.uk",
    handle: "@BillCashMP",
  },
  {
    name: "Miriam Cates",
    party: "Conservative",
    constituency: "Penistone and Stocksbridge",
    email: "miriam.cates.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Maria Caulfield",
    party: "Conservative",
    constituency: "Lewes",
    email: "maria.caulfield.mp@parliament.uk",
    handle: "@mariacaulfield",
  },
  {
    name: "Alex Chalk",
    party: "Conservative",
    constituency: "Cheltenham",
    email: "alex.chalk.mp@parliament.uk",
    handle: "@AlexChalkChelt",
  },
  {
    name: "Wendy Chamberlain",
    party: "Liberal Democrat",
    constituency: "North East Fife",
    email: "wendy.chamberlain.mp@parliament.uk",
    handle: "@wendychambLD",
  },
  {
    name: "Sarah Champion",
    party: "Labour",
    constituency: "Rotherham",
    email: "sarah.champion.mp@parliament.uk",
    handle: "@SarahChampionMP",
  },
  {
    name: "Douglas Chapman",
    party: "Scottish National Party",
    constituency: "Dunfermline and West Fife",
    email: "douglas.chapman.mp@parliament.uk",
    handle: "@DougChapmanSNP",
  },
  {
    name: "Bambos Charalambous",
    party: "Labour",
    constituency: "Enfield, Southgate",
    email: "bambos.charalambous.mp@parliament.uk",
    handle: "@BambosMP",
  },
  {
    name: "Joanna Cherry",
    party: "Scottish National Party",
    constituency: "Edinburgh South West",
    email: "joanna.cherry.mp@parliament.uk",
    handle: "@joannaccherry",
  },
  {
    name: "Rehman Chishti",
    party: "Conservative",
    constituency: "Gillingham and Rainham",
    email: "rehman.chishti.mp@parliament.uk",
    handle: "@Rehman_Chishti",
  },
  {
    name: "Sir Christopher Chope",
    party: "Conservative",
    constituency: "Christchurch",
    email: "chopec@parliament.uk",
    handle: null,
  },
  {
    name: "Jo Churchill",
    party: "Conservative",
    constituency: "Bury St Edmunds",
    email: "jo.churchill.mp@parliament.uk",
    handle: "@Jochurchill_MP",
  },
  {
    name: "Feryal Clark",
    party: "Labour",
    constituency: "Enfield North",
    email: "feryal.clark.mp@parliament.uk",
    handle: "@FeryalClark",
  },
  {
    name: "Greg Clark",
    party: "Conservative",
    constituency: "Tunbridge Wells",
    email: "gregclarkmp@parliament.uk",
    handle: "@GregClarkMP",
  },
  {
    name: "Mr Simon Clarke",
    party: "Conservative",
    constituency: "Middlesbrough South and East Cleveland",
    email: "simon.clarke.mp@parliament.uk",
    handle: "@SimonClarkeMP",
  },
  {
    name: "Theo Clarke",
    party: "Conservative",
    constituency: "Stafford",
    email: "theo.clarke.mp@parliament.uk",
    handle: "@theodoraclarke",
  },
  {
    name: "Brendan Clarke-Smith",
    party: "Conservative",
    constituency: "Bassetlaw",
    email: "brendan.clarkesmith.mp@parliament.uk",
    handle: "@Bren4Bassetlaw",
  },
  {
    name: "Chris Clarkson",
    party: "Conservative",
    constituency: "Heywood and Middleton",
    email: "chris.clarkson.mp@parliament.uk",
    handle: "@ChrisClarksonMP",
  },
  {
    name: "James Cleverly",
    party: "Conservative",
    constituency: "Braintree",
    email: "james.cleverly.mp@parliament.uk",
    handle: "@JamesCleverly",
  },
  {
    name: "Sir Geoffrey Clifton-Brown",
    party: "Conservative",
    constituency: "The Cotswolds",
    email: "cliftonbrowng@parliament.uk",
    handle: null,
  },
  {
    name: "Dr Th\u00e9r\u00e8se Coffey",
    party: "Conservative",
    constituency: "Suffolk Coastal",
    email: "therese.coffey.mp@parliament.uk",
    handle: "@theresecoffey",
  },
  {
    name: "Elliot Colburn",
    party: "Conservative",
    constituency: "Carshalton and Wallington",
    email: "elliot.colburn.mp@parliament.uk",
    handle: "@ElliotColburn",
  },
  {
    name: "Damian Collins",
    party: "Conservative",
    constituency: "Folkestone and Hythe",
    email: "damian.collins.mp@parliament.uk",
    handle: "@DamianCollins",
  },
  {
    name: "Daisy Cooper",
    party: "Liberal Democrat",
    constituency: "St Albans",
    email: "daisy.cooper.mp@parliament.uk",
    handle: "@libdemdaisy",
  },
  {
    name: "Yvette Cooper",
    party: "Labour",
    constituency: "Normanton, Pontefract and Castleford",
    email: "coopery@parliament.uk",
    handle: "@YvetteCooperMP",
  },
  {
    name: "Jeremy Corbyn",
    party: "Independent",
    constituency: "Islington North",
    email: "jeremy.corbyn.mp@parliament.uk",
    handle: "@jeremycorbyn",
  },
  {
    name: "Alberto Costa",
    party: "Conservative",
    constituency: "South Leicestershire",
    email: "alberto.costa.mp@parliament.uk",
    handle: "@AlbertoCostaMP",
  },
  {
    name: "Robert Courts",
    party: "Conservative",
    constituency: "Witney",
    email: "robert.courts.mp@parliament.uk",
    handle: "@robertcourts",
  },
  {
    name: "Claire Coutinho",
    party: "Conservative",
    constituency: "East Surrey",
    email: "claire.coutinho.mp@parliament.uk",
    handle: "@ClaireCoutinho",
  },
  {
    name: "Ronnie Cowan",
    party: "Scottish National Party",
    constituency: "Inverclyde",
    email: "ronnie.cowan.mp@parliament.uk",
    handle: "@ronniecowan",
  },
  {
    name: "Sir Geoffrey Cox",
    party: "Conservative",
    constituency: "Torridge and West Devon",
    email: "coxg@parliament.uk",
    handle: "@Geoffrey_Cox",
  },
  {
    name: "Neil Coyle",
    party: "Independent",
    constituency: "Bermondsey and Old Southwark",
    email: "neil.coyle.mp@parliament.uk",
    handle: "@coyleneil",
  },
  {
    name: "Stephen Crabb",
    party: "Conservative",
    constituency: "Preseli Pembrokeshire",
    email: "stephen.crabb.mp@parliament.uk",
    handle: "@SCrabbPembs",
  },
  {
    name: "Angela Crawley",
    party: "Scottish National Party",
    constituency: "Lanark and Hamilton East",
    email: "angela.crawley.mp@parliament.uk",
    handle: "@AngelaCrawley30",
  },
  {
    name: "Stella Creasy",
    party: "Labour (Co-op)",
    constituency: "Walthamstow",
    email: "stella.creasy.mp@parliament.uk",
    handle: "@stellacreasy",
  },
  {
    name: "Virginia Crosbie",
    party: "Conservative",
    constituency: "Ynys M\u00f4n",
    email: "virginia.crosbie.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Tracey Crouch",
    party: "Conservative",
    constituency: "Chatham and Aylesford",
    email: "tracey.crouch.mp@parliament.uk",
    handle: "@tracey_crouch",
  },
  {
    name: "Jon Cruddas",
    party: "Labour",
    constituency: "Dagenham and Rainham",
    email: "cruddasj@parliament.uk",
    handle: "@JonCruddas_1",
  },
  {
    name: "John Cryer",
    party: "Labour",
    constituency: "Leyton and Wanstead",
    email: "john.cryer.mp@parliament.uk",
    handle: "@JohnCryerMP",
  },
  {
    name: "Judith Cummins",
    party: "Labour",
    constituency: "Bradford South",
    email: "judith.cummins.mp@parliament.uk",
    handle: "@JudithCummins",
  },
  {
    name: "Alex Cunningham",
    party: "Labour",
    constituency: "Stockton North",
    email: "alex.cunningham.mp@parliament.uk",
    handle: "@ACunninghamMP",
  },
  {
    name: "Janet Daby",
    party: "Labour",
    constituency: "Lewisham East",
    email: "janet.daby.mp@parliament.uk",
    handle: "@JanetDaby",
  },
  {
    name: "Ashley Dalton",
    party: "Labour",
    constituency: "West Lancashire",
    email: "ashley.dalton.mp@parliament.uk",
    handle: "@rosie4westlancs",
  },
  {
    name: "James Daly",
    party: "Conservative",
    constituency: "Bury North",
    email: "james.daly.mp@parliament.uk",
    handle: "@JamesDalyMP",
  },
  {
    name: "Ed Davey",
    party: "Liberal Democrat",
    constituency: "Kingston and Surbiton",
    email: "edward.davey.mp@parliament.uk",
    handle: "@EdwardJDavey",
  },
  {
    name: "Wayne David",
    party: "Labour",
    constituency: "Caerphilly",
    email: "davidw@parliament.uk",
    handle: "@WayneDavid_MP",
  },
  {
    name: "David T C  Davies",
    party: "Conservative",
    constituency: "Monmouth",
    email: "david.davies.mp@parliament.uk",
    handle: "@DavidTCDavies",
  },
  {
    name: "Gareth Davies",
    party: "Conservative",
    constituency: "Grantham and Stamford",
    email: "gareth.davies.mp@parliament.uk",
    handle: "@GarethDavies_MP",
  },
  {
    name: "Geraint Davies",
    party: "Labour (Co-op)",
    constituency: "Swansea West",
    email: "geraint.davies.mp@parliament.uk",
    handle: "@GeraintDaviesMP",
  },
  {
    name: "Dr James Davies",
    party: "Conservative",
    constituency: "Vale of Clwyd",
    email: "james.davies.mp@parliament.uk",
    handle: "@JamesDavies",
  },
  {
    name: "Mims Davies",
    party: "Conservative",
    constituency: "Mid Sussex",
    email: "mims.davies.mp@parliament.uk",
    handle: "@mimsdavies",
  },
  {
    name: "Philip Davies",
    party: "Conservative",
    constituency: "Shipley",
    email: "daviesp@parliament.uk",
    handle: "@PhilipDaviesUK",
  },
  {
    name: "Alex Davies-Jones",
    party: "Labour",
    constituency: "Pontypridd",
    email: "alex.daviesjones.mp@parliament.uk",
    handle: "@AlexDaviesJones",
  },
  {
    name: "Mr David Davis",
    party: "Conservative",
    constituency: "Haltemprice and Howden",
    email: "david.davis.mp@parliament.uk",
    handle: "@DavidDavisMP",
  },
  {
    name: "Dehenna Davison",
    party: "Conservative",
    constituency: "Bishop Auckland",
    email: "dehenna.davison.mp@parliament.uk",
    handle: "@DehennaDavison",
  },
  {
    name: "Martyn Day",
    party: "Scottish National Party",
    constituency: "Linlithgow and East Falkirk",
    email: "martyn.day.mp@parliament.uk",
    handle: "@MartynDaySNP",
  },
  {
    name: "Marsha De Cordova",
    party: "Labour",
    constituency: "Battersea",
    email: "marsha.decordova.mp@parliament.uk",
    handle: "@MarshadeCordova",
  },
  {
    name: "Thangam Debbonaire",
    party: "Labour",
    constituency: "Bristol West",
    email: "thangam.debbonaire.mp@parliament.uk",
    handle: "@ThangamMP",
  },
  {
    name: "Mr Tanmanjeet Singh Dhesi",
    party: "Labour",
    constituency: "Slough",
    email: "tan.dhesi.mp@parliament.uk",
    handle: "@TanDhesi",
  },
  {
    name: "Dame Caroline Dinenage",
    party: "Conservative",
    constituency: "Gosport",
    email: "caroline.dinenage.mp@parliament.uk",
    handle: "@cj_dinenage",
  },
  {
    name: "Miss Sarah Dines",
    party: "Conservative",
    constituency: "Derbyshire Dales",
    email: "sarah.dines.mp@parliament.uk",
    handle: "@Dines4Dales",
  },
  {
    name: "Samantha Dixon",
    party: "Labour",
    constituency: "City of Chester",
    email: "Samantha.dixon.mp@parliament.uk",
    handle: "@SamanthaDixonMP",
  },
  {
    name: "Mr Jonathan Djanogly",
    party: "Conservative",
    constituency: "Huntingdon",
    email: "jonathan.djanogly.mp@parliament.uk",
    handle: "@JDjanogly",
  },
  {
    name: "Leo Docherty",
    party: "Conservative",
    constituency: "Aldershot",
    email: "leo.docherty.mp@parliament.uk",
    handle: "@LeoDochertyUK",
  },
  {
    name: "Martin Docherty-Hughes",
    party: "Scottish National Party",
    constituency: "West Dunbartonshire",
    email: "martin.docherty.mp@parliament.uk",
    handle: "@MartinJDocherty",
  },
  {
    name: "Anneliese Dodds",
    party: "Labour (Co-op)",
    constituency: "Oxford East",
    email: "anneliese.dodds.mp@parliament.uk",
    handle: "@AnnelieseDodds",
  },
  {
    name: "Sir Jeffrey M Donaldson",
    party: "Democratic Unionist Party",
    constituency: "Lagan Valley",
    email: "jeffrey.donaldson.mp@parliament.uk",
    handle: "@J_Donaldson_MP",
  },
  {
    name: "Michelle Donelan",
    party: "Conservative",
    constituency: "Chippenham",
    email: "michelle.donelan.mp@parliament.uk",
    handle: "@michelledonelan",
  },
  {
    name: "Dave Doogan",
    party: "Scottish National Party",
    constituency: "Angus",
    email: "dave.doogan.mp@parliament.uk",
    handle: "@DaveDooganSNP",
  },
  {
    name: "Allan Dorans",
    party: "Scottish National Party",
    constituency: "Ayr, Carrick and Cumnock",
    email: "allan.dorans.mp@parliament.uk",
    handle: "@allandoransMP",
  },
  {
    name: "Alistair Strathern",
    party: "Labour",
    constituency: "Mid Bedfordshire",
    email: "nadine.dorries.mp@parliament.uk",
    handle: "@alistrathern",
  },
  {
    name: "Steve Double",
    party: "Conservative",
    constituency: "St Austell and Newquay",
    email: "steve.double.mp@parliament.uk",
    handle: "@stevedouble",
  },
  {
    name: "Stephen Doughty",
    party: "Labour (Co-op)",
    constituency: "Cardiff South and Penarth",
    email: "stephen.doughty.mp@parliament.uk",
    handle: "@SDoughtyMP",
  },
  {
    name: "Peter Dowd",
    party: "Labour",
    constituency: "Bootle",
    email: "peter.dowd.mp@parliament.uk",
    handle: "@Peter_Dowd",
  },
  {
    name: "Oliver Dowden",
    party: "Conservative",
    constituency: "Hertsmere",
    email: "oliver.dowden.mp@parliament.uk",
    handle: "@OliverDowden",
  },
  {
    name: "Jackie Doyle-Price",
    party: "Conservative",
    constituency: "Thurrock",
    email: "jackie.doyleprice.mp@parliament.uk",
    handle: "@JackieDP",
  },
  {
    name: "Richard Drax",
    party: "Conservative",
    constituency: "South Dorset",
    email: "richard.drax.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mrs Flick Drummond",
    party: "Conservative",
    constituency: "Meon Valley",
    email: "flick.drummond.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Sir James Duddridge",
    party: "Conservative",
    constituency: "Rochford and Southend East",
    email: "james@jamesduddridge.com",
    handle: "@JamesDuddridge",
  },
  {
    name: "Rosie Duffield",
    party: "Labour",
    constituency: "Canterbury",
    email: "rosie.duffield.mp@parliament.uk",
    handle: "@RosieDuffield1",
  },
  {
    name: "David Duguid",
    party: "Conservative",
    constituency: "Banff and Buchan",
    email: "david.duguid.mp@parliament.uk",
    handle: "@david_duguid",
  },
  {
    name: "Sir Iain Duncan Smith",
    party: "Conservative",
    constituency: "Chingford and Woodford Green",
    email: "Iain.duncansmith.mp@parliament.uk",
    handle: "@MPIainDS",
  },
  {
    name: "Philip Dunne",
    party: "Conservative",
    constituency: "Ludlow",
    email: "philip.dunne.mp@parliament.uk",
    handle: "@Dunne4Ludlow",
  },
  {
    name: "Dame Angela Eagle",
    party: "Labour",
    constituency: "Wallasey",
    email: "eaglea@parliament.uk",
    handle: "@angelaeagle",
  },
  {
    name: "Maria Eagle",
    party: "Labour",
    constituency: "Garston and Halewood",
    email: "maria.eagle.mp@parliament.uk",
    handle: "@meaglemp",
  },
  {
    name: "Colum Eastwood",
    party: "Social Democratic & Labour Party",
    constituency: "Foyle",
    email: "colum.eastwood.mp@parliament.uk",
    handle: "@columeastwood",
  },
  {
    name: "Mark Eastwood",
    party: "Conservative",
    constituency: "Dewsbury",
    email: "mark.eastwood.mp@parliament.uk",
    handle: "@mark4dewsbury",
  },
  {
    name: "Jonathan Edwards",
    party: "Independent",
    constituency: "Carmarthen East and Dinefwr",
    email: "jonathan.edwards.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Ruth Edwards",
    party: "Conservative",
    constituency: "Rushcliffe",
    email: "ruth.edwards.mp@parliament.uk",
    handle: "@RuthEdwardsMP",
  },
  {
    name: "Clive Efford",
    party: "Labour",
    constituency: "Eltham",
    email: "effordc@parliament.uk",
    handle: "@CliveEfford",
  },
  {
    name: "Julie Elliott",
    party: "Labour",
    constituency: "Sunderland Central",
    email: "julie.elliott.mp@parliament.uk",
    handle: "@JulieElliottMP",
  },
  {
    name: "Michael Ellis",
    party: "Conservative",
    constituency: "Northampton North",
    email: "michael.ellis.mp@parliament.uk",
    handle: "@Michael_Ellis1",
  },
  {
    name: "Mr Tobias Ellwood",
    party: "Conservative",
    constituency: "Bournemouth East",
    email: "tobias.ellwood.mp@parliament.uk",
    handle: "@Tobias_Ellwood",
  },
  {
    name: "Chris Elmore",
    party: "Labour",
    constituency: "Ogmore",
    email: "Chris.Elmore.mp@parliament.uk",
    handle: "@CPJElmore",
  },
  {
    name: "Mrs Natalie Elphicke",
    party: "Conservative",
    constituency: "Dover",
    email: "natalie.elphicke.mp@parliament.uk",
    handle: "@NatalieElphicke",
  },
  {
    name: "Florence Eshalomi",
    party: "Labour (Co-op)",
    constituency: "Vauxhall",
    email: "florence.eshalomi.mp@parliament.uk",
    handle: "@FloEshalomi",
  },
  {
    name: "Bill Esterson",
    party: "Labour",
    constituency: "Sefton Central",
    email: "bill.esterson.mp@parliament.uk",
    handle: "@Bill_Esterson",
  },
  {
    name: "George Eustice",
    party: "Conservative",
    constituency: "Camborne and Redruth",
    email: "george.eustice.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Chris Evans",
    party: "Labour (Co-op)",
    constituency: "Islwyn",
    email: "chris.evans.mp@parliament.uk",
    handle: "@Chris_EvansMP",
  },
  {
    name: "Dr Luke Evans",
    party: "Conservative",
    constituency: "Bosworth",
    email: "luke.evans.mp@parliament.uk",
    handle: "@drlukeevans",
  },
  {
    name: "Mr Nigel Evans",
    party: "Conservative",
    constituency: "Ribble Valley",
    email: "evansn@parliament.uk",
    handle: "@nigelmp",
  },
  {
    name: "Sir David Evennett",
    party: "Conservative",
    constituency: "Bexleyheath and Crayford",
    email: "david.evennett.mp@parliament.uk",
    handle: "@DavidEvennettMP",
  },
  {
    name: "Ben Everitt",
    party: "Conservative",
    constituency: "Milton Keynes North",
    email: "ben.everitt.mp@parliament.uk",
    handle: "@Ben_Everitt",
  },
  {
    name: "Michael Fabricant",
    party: "Conservative",
    constituency: "Lichfield",
    email: "michael.fabricant.mp@parliament.uk",
    handle: "@Mike_Fabricant",
  },
  {
    name: "Laura Farris",
    party: "Conservative",
    constituency: "Newbury",
    email: "laura.farris.mp@parliament.uk",
    handle: "@Laura__Farris",
  },
  {
    name: "Tim Farron",
    party: "Liberal Democrat",
    constituency: "Westmorland and Lonsdale",
    email: "farront@parliament.uk",
    handle: "@timfarron",
  },
  {
    name: "Stephen Farry",
    party: "Alliance",
    constituency: "North Down",
    email: "stephen.farry.mp@parliament.uk",
    handle: "@StephenFarryMP",
  },
  {
    name: "Simon Fell",
    party: "Conservative",
    constituency: "Barrow and Furness",
    email: "simon.fell.mp@parliament.uk",
    handle: "@simonfell",
  },
  {
    name: "Marion Fellows",
    party: "Scottish National Party",
    constituency: "Motherwell and Wishaw",
    email: "marion.fellows.mp@parliament.uk",
    handle: "@marionfellows",
  },
  {
    name: "Michael Shanks",
    party: "Labour",
    constituency: "Rutherglen and Hamilton West",
    email: "margaret.ferrier.mp@parliament.uk",
    handle: "@mgshanks",
  },
  {
    name: "John Finucane",
    party: "Sinn F\u00e9in",
    constituency: "Belfast North",
    email: "john.finucane.mp@parliament.uk",
    handle: "@johnfinucane",
  },
  {
    name: "Anna Firth",
    party: "Conservative",
    constituency: "Southend West",
    email: "anna.firth.mp@parliament.uk",
    handle: "@Anna_Firth",
  },
  {
    name: "Colleen Fletcher",
    party: "Labour",
    constituency: "Coventry North East",
    email: "colleen.fletcher.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Katherine Fletcher",
    party: "Conservative",
    constituency: "South Ribble",
    email: "katherine.fletcher.mp@parliament.uk",
    handle: "@K_Fletcher_MP",
  },
  {
    name: "Mark Fletcher",
    party: "Conservative",
    constituency: "Bolsover",
    email: "mark.fletcher.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Nick Fletcher",
    party: "Conservative",
    constituency: "Don Valley",
    email: "nick.fletcher.mp@parliament.uk",
    handle: "@NickFletcherMP",
  },
  {
    name: "Stephen Flynn",
    party: "Scottish National Party",
    constituency: "Aberdeen South",
    email: "stephen.flynn.mp@parliament.uk",
    handle: "@StephenFlynnSNP",
  },
  {
    name: "Richard Foord",
    party: "Liberal Democrat",
    constituency: "Tiverton and Honiton",
    email: "richard.foord.mp@parliament.uk",
    handle: "@RichardFoordLD",
  },
  {
    name: "Vicky Ford",
    party: "Conservative",
    constituency: "Chelmsford",
    email: "vicky.ford.mp@parliament.uk",
    handle: "@vickyford",
  },
  {
    name: "Kevin Foster",
    party: "Conservative",
    constituency: "Torbay",
    email: "kevin.foster.mp@parliament.uk",
    handle: "@kevin_j_foster",
  },
  {
    name: "Yvonne Fovargue",
    party: "Labour",
    constituency: "Makerfield",
    email: "yvonne.fovargue.mp@parliament.uk",
    handle: "@Y_FovargueMP",
  },
  {
    name: "Dr Liam Fox",
    party: "Conservative",
    constituency: "North Somerset",
    email: "liam.fox.mp@parliament.uk",
    handle: "@LiamFox",
  },
  {
    name: "Vicky Foxcroft",
    party: "Labour",
    constituency: "Lewisham, Deptford",
    email: "vicky.foxcroft.mp@parliament.uk",
    handle: "@vickyfoxcroft",
  },
  {
    name: "Mary Kelly Foy",
    party: "Labour",
    constituency: "City of Durham",
    email: "mary.foy.mp@parliament.uk",
    handle: "@marykfoy",
  },
  {
    name: "Mr Mark Francois",
    party: "Conservative",
    constituency: "Rayleigh and Wickford",
    email: "mark.francois.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Lucy Frazer",
    party: "Conservative",
    constituency: "South East Cambridgeshire",
    email: "lucy.frazer.mp@parliament.uk",
    handle: "@lucyfrazermp",
  },
  {
    name: "George Freeman",
    party: "Conservative",
    constituency: "Mid Norfolk",
    email: "george.freeman.mp@parliament.uk",
    handle: "@GeorgeFreemanMP",
  },
  {
    name: "Mike Freer",
    party: "Conservative",
    constituency: "Finchley and Golders Green",
    email: "mike.freer.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mr Louie French",
    party: "Conservative",
    constituency: "Old Bexley and Sidcup",
    email: "louie.french.mp@parliament.uk",
    handle: "@louie_french",
  },
  {
    name: "Richard Fuller",
    party: "Conservative",
    constituency: "North East Bedfordshire",
    email: "richard.fuller.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Gill Furniss",
    party: "Labour",
    constituency: "Sheffield, Brightside and Hillsborough",
    email: "gill.furniss.mp@parliament.uk",
    handle: "@GillFurnissMP",
  },
  {
    name: "Mr Marcus Fysh",
    party: "Conservative",
    constituency: "Yeovil",
    email: "marcus.fysh.mp@parliament.uk",
    handle: "@MarcusFysh",
  },
  {
    name: "Sir Roger Gale",
    party: "Conservative",
    constituency: "North Thanet",
    email: "galerj@parliament.uk",
    handle: "@SirRogerGale",
  },
  {
    name: "Barry Gardiner",
    party: "Labour",
    constituency: "Brent North",
    email: "gardinerb@parliament.uk",
    handle: "@BarryGardiner",
  },
  {
    name: "Mark Garnier",
    party: "Conservative",
    constituency: "Wyre Forest",
    email: "mark.garnier.mp@parliament.uk",
    handle: "@Mark4WyreForest",
  },
  {
    name: "Ms Nusrat Ghani",
    party: "Conservative",
    constituency: "Wealden",
    email: "nusrat.ghani.mp@parliament.uk",
    handle: "@Nus_Ghani",
  },
  {
    name: "Nick Gibb",
    party: "Conservative",
    constituency: "Bognor Regis and Littlehampton",
    email: "gibbn@parliament.uk",
    handle: "@NickGibbUK",
  },
  {
    name: "Patricia Gibson",
    party: "Scottish National Party",
    constituency: "North Ayrshire and Arran",
    email: "patricia.gibson.mp@parliament.uk",
    handle: "@PGibsonSNP",
  },
  {
    name: "Peter Gibson",
    party: "Conservative",
    constituency: "Darlington",
    email: "peter.gibson.mp@parliament.uk",
    handle: "@Gibbo4Darlo",
  },
  {
    name: "Jo Gideon",
    party: "Conservative",
    constituency: "Stoke-on-Trent Central",
    email: "jo.gideon.mp@parliament.uk",
    handle: "@jogideon",
  },
  {
    name: "Michelle Gildernew",
    party: "Sinn F\u00e9in",
    constituency: "Fermanagh and South Tyrone",
    email: "michelle.gildernew.mp@parliament.uk",
    handle: "@gildernewm",
  },
  {
    name: "Preet Kaur Gill",
    party: "Labour (Co-op)",
    constituency: "Birmingham, Edgbaston",
    email: "preet.gill.mp@parliament.uk",
    handle: "@PreetKGillMP",
  },
  {
    name: "Paul Girvan",
    party: "Democratic Unionist Party",
    constituency: "South Antrim",
    email: "paul.girvan.mp@parliament.uk",
    handle: "@PaulGirvanMP",
  },
  {
    name: "John Glen",
    party: "Conservative",
    constituency: "Salisbury",
    email: "john.glen.mp@parliament.uk",
    handle: "@JohnGlenUK",
  },
  {
    name: "Mary Glindon",
    party: "Labour",
    constituency: "North Tyneside",
    email: "mary.glindon.mp@parliament.uk",
    handle: "@GlindonMary",
  },
  {
    name: "Sir Robert Goodwill",
    party: "Conservative",
    constituency: "Scarborough and Whitby",
    email: "robert.goodwill.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Michael Gove",
    party: "Conservative",
    constituency: "Surrey Heath",
    email: "michael.gove.mp@parliament.uk",
    handle: "@michaelgove",
  },
  {
    name: "Patrick Grady",
    party: "Scottish National Party",
    constituency: "Glasgow North",
    email: "patrick.grady.mp@parliament.uk",
    handle: "@GradySNP",
  },
  {
    name: "Richard Graham",
    party: "Conservative",
    constituency: "Gloucester",
    email: "richard.graham.mp@parliament.uk",
    handle: "@RichardGrahamUK",
  },
  {
    name: "Mrs Helen Grant",
    party: "Conservative",
    constituency: "Maidstone and The Weald",
    email: "helen.grant.mp@parliament.uk",
    handle: "@HelenGrantMP",
  },
  {
    name: "Peter Grant",
    party: "Scottish National Party",
    constituency: "Glenrothes",
    email: "peter.grant.mp@parliament.uk",
    handle: "@PeterGrantMP",
  },
  {
    name: "James Gray",
    party: "Conservative",
    constituency: "North Wiltshire",
    email: "jamesgraymp@parliament.uk",
    handle: "@JGray",
  },
  {
    name: "Chris Grayling",
    party: "Conservative",
    constituency: "Epsom and Ewell",
    email: "chris.grayling.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Chris Green",
    party: "Conservative",
    constituency: "Bolton West",
    email: "chris.green.mp@parliament.uk",
    handle: "@CGreenUK",
  },
  {
    name: "Damian Green",
    party: "Conservative",
    constituency: "Ashford",
    email: "damian.green.mp@parliament.uk",
    handle: "@DamianGreen",
  },
  {
    name: "Sarah Green",
    party: "Liberal Democrat",
    constituency: "Chesham and Amersham",
    email: "sarah.green.mp@parliament.uk",
    handle: "@SarahGreenLD",
  },
  {
    name: "Lilian Greenwood",
    party: "Labour",
    constituency: "Nottingham South",
    email: "lilian.greenwood.mp@parliament.uk",
    handle: "@LilianGreenwood",
  },
  {
    name: "Margaret Greenwood",
    party: "Labour",
    constituency: "Wirral West",
    email: "margaret.greenwood.mp@parliament.uk",
    handle: "@MGreenwoodWW",
  },
  {
    name: "Andrew Griffith",
    party: "Conservative",
    constituency: "Arundel and South Downs",
    email: "andrew.griffith.mp@parliament.uk",
    handle: "@griffitha",
  },
  {
    name: "Dame Nia Griffith",
    party: "Labour",
    constituency: "Llanelli",
    email: "nia.griffith.mp@parliament.uk",
    handle: "@NiaGriffithMP",
  },
  {
    name: "James Grundy",
    party: "Conservative",
    constituency: "Leigh",
    email: "james.grundy.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Jonathan Gullis",
    party: "Conservative",
    constituency: "Stoke-on-Trent North",
    email: "jonathan.gullis.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Andrew Gwynne",
    party: "Labour",
    constituency: "Denton and Reddish",
    email: "gwynnea@parliament.uk",
    handle: "@GwynneMP",
  },
  {
    name: "Louise Haigh",
    party: "Labour",
    constituency: "Sheffield, Heeley",
    email: "louise.haigh.mp@parliament.uk",
    handle: "@LouHaigh",
  },
  {
    name: "Robert Halfon",
    party: "Conservative",
    constituency: "Harlow",
    email: "halfon4harlow@roberthalfon.com",
    handle: "@halfon4harlowMP",
  },
  {
    name: "Luke Hall",
    party: "Conservative",
    constituency: "Thornbury and Yate",
    email: "luke.hall.mp@parliament.uk",
    handle: "@LukeHall",
  },
  {
    name: "Fabian Hamilton",
    party: "Labour",
    constituency: "Leeds North East",
    email: "fabian.hamilton.mp@parliament.uk",
    handle: "@FabianLeedsNE",
  },
  {
    name: "Mrs Paulette Hamilton",
    party: "Labour",
    constituency: "Birmingham, Erdington",
    email: "paulette.hamilton.mp@parliament.uk",
    handle: "@JackDromeyMP",
  },
  {
    name: "Stephen Hammond",
    party: "Conservative",
    constituency: "Wimbledon",
    email: "stephen.hammond.mp@parliament.uk",
    handle: "@S_Hammond",
  },
  {
    name: "Matt Hancock",
    party: "Independent",
    constituency: "West Suffolk",
    email: "matt.hancock.mp@parliament.uk",
    handle: "@MattHancock",
  },
  {
    name: "Greg Hands",
    party: "Conservative",
    constituency: "Chelsea and Fulham",
    email: "handsg@parliament.uk",
    handle: "@GregHands",
  },
  {
    name: "Claire Hanna",
    party: "Social Democratic & Labour Party",
    constituency: "Belfast South",
    email: "claire.hanna.mp@parliament.uk",
    handle: "@ClaireHanna",
  },
  {
    name: "Neale Hanvey",
    party: "Alba Party",
    constituency: "Kirkcaldy and Cowdenbeath",
    email: "neale.hanvey.mp@parliament.uk",
    handle: "@JNHanvey",
  },
  {
    name: "Emma Hardy",
    party: "Labour",
    constituency: "Kingston upon Hull West and Hessle",
    email: "emma.hardy.mp@parliament.uk",
    handle: "@EmmaHardyMP",
  },
  {
    name: "Ms Harriet Harman",
    party: "Labour",
    constituency: "Camberwell and Peckham",
    email: "harriet.harman.mp@parliament.uk",
    handle: "@HarrietHarman",
  },
  {
    name: "Mr Mark Harper",
    party: "Conservative",
    constituency: "Forest of Dean",
    email: "mark.harper.mp@parliament.uk",
    handle: "@Mark_J_Harper",
  },
  {
    name: "Carolyn Harris",
    party: "Labour",
    constituency: "Swansea East",
    email: "carolyn.harris.mp@parliament.uk",
    handle: "@carolynharris24",
  },
  {
    name: "Rebecca Harris",
    party: "Conservative",
    constituency: "Castle Point",
    email: "rebecca.harris.mp@parliament.uk",
    handle: "@RebeccaHarrisMP",
  },
  {
    name: "Trudy Harrison",
    party: "Conservative",
    constituency: "Copeland",
    email: "trudy.harrison.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Sally-Ann Hart",
    party: "Conservative",
    constituency: "Hastings and Rye",
    email: "sallyann.hart.mp@parliament.uk",
    handle: "@SallyAnn1066",
  },
  {
    name: "Simon Hart",
    party: "Conservative",
    constituency: "Carmarthen West and South Pembrokeshire",
    email: "simon.hart.mp@parliament.uk",
    handle: "@Simonhartmp",
  },
  {
    name: "Helen Hayes",
    party: "Labour",
    constituency: "Dulwich and West Norwood",
    email: "helen.hayes.mp@parliament.uk",
    handle: "@helenhayes_",
  },
  {
    name: "Sir John Hayes",
    party: "Conservative",
    constituency: "South Holland and The Deepings",
    email: "hayesj@parliament.uk",
    handle: null,
  },
  {
    name: "Chris Hazzard",
    party: "Sinn F\u00e9in",
    constituency: "South Down",
    email: "chris.hazzard.mp@parliament.uk",
    handle: "@ChrisHazzardSF",
  },
  {
    name: "Sir Oliver Heald",
    party: "Conservative",
    constituency: "North East Hertfordshire",
    email: "Oliver.heald.mp@parliament.uk",
    handle: "@OliverHealdUK",
  },
  {
    name: "John Healey",
    party: "Labour",
    constituency: "Wentworth and Dearne",
    email: "john.healey.mp@parliament.uk",
    handle: "@JohnHealey_MP",
  },
  {
    name: "James Heappey",
    party: "Conservative",
    constituency: "Wells",
    email: "james.heappey.mp@parliament.uk",
    handle: "@JSHeappey",
  },
  {
    name: "Chris Heaton-Harris",
    party: "Conservative",
    constituency: "Daventry",
    email: "chris.heatonharris.mp@parliament.uk",
    handle: "@chhcalling",
  },
  {
    name: "Gordon Henderson",
    party: "Conservative",
    constituency: "Sittingbourne and Sheppey",
    email: "gordon.henderson.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Sir Mark Hendrick",
    party: "Labour (Co-op)",
    constituency: "Preston",
    email: "mark.hendrick.mp@parliament.uk",
    handle: "@MpHendrick",
  },
  {
    name: "Drew Hendry",
    party: "Scottish National Party",
    constituency: "Inverness, Nairn, Badenoch and Strathspey",
    email: "drew.hendry.mp@parliament.uk",
    handle: "@drewhendrySNP",
  },
  {
    name: "Darren Henry",
    party: "Conservative",
    constituency: "Broxtowe",
    email: "darren.henry.mp@parliament.uk",
    handle: "@DarrenG_Henry",
  },
  {
    name: "Antony Higginbotham",
    party: "Conservative",
    constituency: "Burnley",
    email: "antony.higginbotham.mp@parliament.uk",
    handle: "@antony_hig",
  },
  {
    name: "Dame Meg Hillier",
    party: "Labour (Co-op)",
    constituency: "Hackney South and Shoreditch",
    email: "meghilliermp@parliament.uk",
    handle: "@Meg_HillierMP",
  },
  {
    name: "Damian Hinds",
    party: "Conservative",
    constituency: "East Hampshire",
    email: "damian.hinds.mp@parliament.uk",
    handle: "@DamianHinds",
  },
  {
    name: "Simon Hoare",
    party: "Conservative",
    constituency: "North Dorset",
    email: "simon.hoare.mp@parliament.uk",
    handle: "@Simon4NDorset",
  },
  {
    name: "Wera Hobhouse",
    party: "Liberal Democrat",
    constituency: "Bath",
    email: "wera.hobhouse.mp@parliament.uk",
    handle: "@Wera_Hobhouse",
  },
  {
    name: "Dame Margaret Hodge",
    party: "Labour",
    constituency: "Barking",
    email: "hodgem@parliament.uk",
    handle: "@margarethodge",
  },
  {
    name: "Mrs Sharon Hodgson",
    party: "Labour",
    constituency: "Washington and Sunderland West",
    email: "sharon.hodgson.mp@parliament.uk",
    handle: "@SharonHodgsonMP",
  },
  {
    name: "Mr Richard Holden",
    party: "Conservative",
    constituency: "North West Durham",
    email: "richard.holden.mp@parliament.uk",
    handle: "@RicHolden",
  },
  {
    name: "Kate Hollern",
    party: "Labour",
    constituency: "Blackburn",
    email: "kate.hollern.mp@parliament.uk",
    handle: "@Kate_HollernMP",
  },
  {
    name: "Kevin Hollinrake",
    party: "Conservative",
    constituency: "Thirsk and Malton",
    email: "kevin.hollinrake.mp@parliament.uk",
    handle: "@kevinhollinrake",
  },
  {
    name: "Mr Philip Hollobone",
    party: "Conservative",
    constituency: "Kettering",
    email: "philip.hollobone.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Adam Holloway",
    party: "Conservative",
    constituency: "Gravesham",
    email: "hollowaya@parliament.uk",
    handle: null,
  },
  {
    name: "Paul Holmes",
    party: "Conservative",
    constituency: "Eastleigh",
    email: "paul.holmes.mp@parliament.uk",
    handle: "@pauljholmes",
  },
  {
    name: "Rachel Hopkins",
    party: "Labour",
    constituency: "Luton South",
    email: "rachel.hopkins.mp@parliament.uk",
    handle: "@rach_hopkins",
  },
  {
    name: "Stewart Hosie",
    party: "Scottish National Party",
    constituency: "Dundee East",
    email: "stewart.hosie.mp@parliament.uk",
    handle: "@StewartHosieSNP",
  },
  {
    name: "Sir George Howarth",
    party: "Labour",
    constituency: "Knowsley",
    email: "george.howarth.mp@parliament.uk",
    handle: null,
  },
  {
    name: "John Howell",
    party: "Conservative",
    constituency: "Henley",
    email: "howelljm@parliament.uk",
    handle: "@JHowellUK",
  },
  {
    name: "Paul Howell",
    party: "Conservative",
    constituency: "Sedgefield",
    email: "paul.howell.mp@parliament.uk",
    handle: "@PaulHowellMP",
  },
  {
    name: "Sir Lindsay Hoyle",
    party: "Speaker",
    constituency: "Chorley",
    email: "speakersoffice@parliament.uk",
    handle: "@LindsayHoyle_MP",
  },
  {
    name: "Nigel Huddleston",
    party: "Conservative",
    constituency: "Mid Worcestershire",
    email: "nigel.huddleston.mp@parliament.uk",
    handle: "@HuddlestonNigel",
  },
  {
    name: "Dr Neil Hudson",
    party: "Conservative",
    constituency: "Penrith and The Border",
    email: "neil.hudson.mp@parliament.uk",
    handle: "@DrNeilHudson",
  },
  {
    name: "Eddie Hughes",
    party: "Conservative",
    constituency: "Walsall North",
    email: "eddie.hughes.mp@parliament.uk",
    handle: "@EddieHughes4WN",
  },
  {
    name: "Jane Hunt",
    party: "Conservative",
    constituency: "Loughborough",
    email: "jane.hunt.mp@parliament.uk",
    handle: "@JaneMHunt",
  },
  {
    name: "Jeremy Hunt",
    party: "Conservative",
    constituency: "South West Surrey",
    email: "huntj@parliament.uk",
    handle: "@Jeremy_Hunt",
  },
  {
    name: "Tom Hunt",
    party: "Conservative",
    constituency: "Ipswich",
    email: "tom.hunt.mp@parliament.uk",
    handle: "@tomhunt1988",
  },
  {
    name: "Dr Rupa Huq",
    party: "Labour",
    constituency: "Ealing Central and Acton",
    email: "rupa.huq.mp@parliament.uk",
    handle: "@RupaHuq",
  },
  {
    name: "Imran Hussain",
    party: "Labour",
    constituency: "Bradford East",
    email: "imran.hussain.mp@parliament.uk",
    handle: "@Imran_HussainMP",
  },
  {
    name: "Mr Alister Jack",
    party: "Conservative",
    constituency: "Dumfries and Galloway",
    email: "alister.jack.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Christine Jardine",
    party: "Liberal Democrat",
    constituency: "Edinburgh West",
    email: "christine.jardine.mp@parliament.uk",
    handle: "@cajardineMP",
  },
  {
    name: "Dan Jarvis",
    party: "Labour",
    constituency: "Barnsley Central",
    email: "dan.jarvis.mp@parliament.uk",
    handle: "@DanJarvisMP",
  },
  {
    name: "Sajid Javid",
    party: "Conservative",
    constituency: "Bromsgrove",
    email: "sajid.javid.mp@parliament.uk",
    handle: "@sajidjavid",
  },
  {
    name: "Mr Ranil Jayawardena",
    party: "Conservative",
    constituency: "North East Hampshire",
    email: "email@ranil.uk",
    handle: "@TeamRanil",
  },
  {
    name: "Sir Bernard Jenkin",
    party: "Conservative",
    constituency: "Harwich and North Essex",
    email: "bernard.jenkin.mp@parliament.uk",
    handle: "@bernardjenkin",
  },
  {
    name: "Mark Jenkinson",
    party: "Conservative",
    constituency: "Workington",
    email: "mark.jenkinson.mp@parliament.uk",
    handle: "@markjenkinsonmp",
  },
  {
    name: "Andrea Jenkyns",
    party: "Conservative",
    constituency: "Morley and Outwood",
    email: "andrea.jenkyns.mp@parliament.uk",
    handle: "@andreajenkyns",
  },
  {
    name: "Robert Jenrick",
    party: "Conservative",
    constituency: "Newark",
    email: "robert.jenrick.mp@parliament.uk",
    handle: "@RobertJenrick",
  },
  {
    name: "Boris Johnson",
    party: "Conservative",
    constituency: "Uxbridge and South Ruislip",
    email: "boris.johnson.mp@parliament.uk",
    handle: "@BorisJohnson",
  },
  {
    name: "Dr Caroline Johnson",
    party: "Conservative",
    constituency: "Sleaford and North Hykeham",
    email: "caroline.johnson.mp@parliament.uk",
    handle: "@drcarolinej",
  },
  {
    name: "Dame Diana Johnson",
    party: "Labour",
    constituency: "Kingston upon Hull North",
    email: "johnsond@parliament.uk",
    handle: "@DianaJohnsonMP",
  },
  {
    name: "Gareth Johnson",
    party: "Conservative",
    constituency: "Dartford",
    email: "gareth.johnson.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Kim Johnson",
    party: "Labour",
    constituency: "Liverpool, Riverside",
    email: "kim.johnson.mp@parliament.uk",
    handle: "@KimJohnsonMP",
  },
  {
    name: "David Johnston",
    party: "Conservative",
    constituency: "Wantage",
    email: "david.johnston.mp@parliament.uk",
    handle: "@david4wantage",
  },
  {
    name: "Andrew Jones",
    party: "Conservative",
    constituency: "Harrogate and Knaresborough",
    email: "andrew.jones.mp@parliament.uk",
    handle: "@AJonesMP",
  },
  {
    name: "Darren Jones",
    party: "Labour",
    constituency: "Bristol North West",
    email: "darren.jones.mp@parliament.uk",
    handle: "@darrenpjones",
  },
  {
    name: "Mr David Jones",
    party: "Conservative",
    constituency: "Clwyd West",
    email: "officeofdavidjonesmp@parliament.uk",
    handle: "@DavidJonesMP",
  },
  {
    name: "Fay Jones",
    party: "Conservative",
    constituency: "Brecon and Radnorshire",
    email: "fay.jones.mp@parliament.uk",
    handle: "@JonesyFay",
  },
  {
    name: "Gerald Jones",
    party: "Labour",
    constituency: "Merthyr Tydfil and Rhymney",
    email: "gerald.jones.mp@parliament.uk",
    handle: "@GeraldJonesLAB",
  },
  {
    name: "Mr Kevan Jones",
    party: "Labour",
    constituency: "North Durham",
    email: "kevanjonesmp@parliament.uk",
    handle: "@KevanJonesMP",
  },
  {
    name: "Mr Marcus Jones",
    party: "Conservative",
    constituency: "Nuneaton",
    email: "marcus.jones.mp@parliament.uk",
    handle: "@Marcus4Nuneaton",
  },
  {
    name: "Ruth Jones",
    party: "Labour",
    constituency: "Newport West",
    email: "ruth.jones.mp@parliament.uk",
    handle: "@RuthNewportWest",
  },
  {
    name: "Sarah Jones",
    party: "Labour",
    constituency: "Croydon Central",
    email: "sarah.jones.mp@parliament.uk",
    handle: "@LabourSJ",
  },
  {
    name: "Simon Jupp",
    party: "Conservative",
    constituency: "East Devon",
    email: "simon.jupp.mp@parliament.uk",
    handle: "@simonjamesjupp",
  },
  {
    name: "Mike Kane",
    party: "Labour",
    constituency: "Wythenshawe and Sale East",
    email: "mike.kane.mp@parliament.uk",
    handle: "@MikeKaneMP",
  },
  {
    name: "Daniel Kawczynski",
    party: "Conservative",
    constituency: "Shrewsbury and Atcham",
    email: "daniel.kawczynski.mp@parliament.uk",
    handle: "@DKShrewsbury",
  },
  {
    name: "Alicia Kearns",
    party: "Conservative",
    constituency: "Rutland and Melton",
    email: "alicia.kearns.mp@parliament.uk",
    handle: "@aliciakearns",
  },
  {
    name: "Gillian Keegan",
    party: "Conservative",
    constituency: "Chichester",
    email: "gillian.keegan.mp@parliament.uk",
    handle: "@GillianKeegan",
  },
  {
    name: "Barbara Keeley",
    party: "Labour",
    constituency: "Worsley and Eccles South",
    email: "keeleyb@parliament.uk",
    handle: "@KeeleyMP",
  },
  {
    name: "Liz Kendall",
    party: "Labour",
    constituency: "Leicester West",
    email: "liz.kendall.mp@parliament.uk",
    handle: "@leicesterliz",
  },
  {
    name: "Afzal Khan",
    party: "Labour",
    constituency: "Manchester, Gorton",
    email: "afzal.khan.mp@parliament.uk",
    handle: "@Afzal4Gorton",
  },
  {
    name: "Stephen Kinnock",
    party: "Labour",
    constituency: "Aberavon",
    email: "stephen.kinnock.mp@parliament.uk",
    handle: "@SKinnock",
  },
  {
    name: "Sir Greg Knight",
    party: "Conservative",
    constituency: "East Yorkshire",
    email: "sothcottt@parliament.uk",
    handle: "@GregKnight",
  },
  {
    name: "Julian Knight",
    party: "Independent",
    constituency: "Solihull",
    email: "julian.knight.mp@parliament.uk",
    handle: "@julianknight15",
  },
  {
    name: "Kate Kniveton",
    party: "Conservative",
    constituency: "Burton",
    email: "kate.kniveton.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Danny Kruger",
    party: "Conservative",
    constituency: "Devizes",
    email: "danny.kruger.mp@parliament.uk",
    handle: "@danny__kruger",
  },
  {
    name: "Kwasi Kwarteng",
    party: "Conservative",
    constituency: "Spelthorne",
    email: "kwasi.kwarteng.mp@parliament.uk",
    handle: "@KwasiKwarteng",
  },
  {
    name: "Peter Kyle",
    party: "Labour",
    constituency: "Hove",
    email: "peter.kyle.mp@parliament.uk",
    handle: "@peterkyle",
  },
  {
    name: "Dame Eleanor Laing",
    party: "Conservative",
    constituency: "Epping Forest",
    email: "eleanor.laing.mp@parliament.uk",
    handle: "@eleanor4epping",
  },
  {
    name: "Ben Lake",
    party: "Plaid Cymru",
    constituency: "Ceredigion",
    email: "ben.lake.mp@parliament.uk",
    handle: "@BenMLake",
  },
  {
    name: "Mr David Lammy",
    party: "Labour",
    constituency: "Tottenham",
    email: "david.lammy.mp@parliament.uk",
    handle: "@DavidLammy",
  },
  {
    name: "John Lamont",
    party: "Conservative",
    constituency: "Berwickshire, Roxburgh and Selkirk",
    email: "john.lamont.mp@parliament.uk",
    handle: "@John2Win",
  },
  {
    name: "Robert Largan",
    party: "Conservative",
    constituency: "High Peak",
    email: "mail@robertlargan.co.uk",
    handle: "@robertlargan",
  },
  {
    name: "Mrs Pauline Latham",
    party: "Conservative",
    constituency: "Mid Derbyshire",
    email: "pauline.latham.mp@parliament.uk",
    handle: "@Pauline_Latham",
  },
  {
    name: "Ian Lavery",
    party: "Labour",
    constituency: "Wansbeck",
    email: "ian.lavery.mp@parliament.uk",
    handle: "@IanLaveryMP",
  },
  {
    name: "Chris Law",
    party: "Scottish National Party",
    constituency: "Dundee West",
    email: "chris.law.mp@parliament.uk",
    handle: "@ChrisLawSNP",
  },
  {
    name: "Kim Leadbeater",
    party: "Labour",
    constituency: "Batley and Spen",
    email: "kim.leadbeater.mp@parliament.uk",
    handle: "@TracyBrabin",
  },
  {
    name: "Andrea Leadsom",
    party: "Conservative",
    constituency: "South Northamptonshire",
    email: "andrea.leadsom.mp@parliament.uk",
    handle: "@andrealeadsom",
  },
  {
    name: "Sir Edward Leigh",
    party: "Conservative",
    constituency: "Gainsborough",
    email: "edward.leigh.mp@parliament.uk",
    handle: "@EdwardLeighMP",
  },
  {
    name: "Ian Levy",
    party: "Conservative",
    constituency: "Blyth Valley",
    email: "ian.levy.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mrs Emma Lewell-Buck",
    party: "Labour",
    constituency: "South Shields",
    email: "emma.lewell-buck.mp@parliament.uk",
    handle: "@EmmaLewellBuck",
  },
  {
    name: "Andrew Lewer",
    party: "Conservative",
    constituency: "Northampton South",
    email: "andrew.lewer.mp@parliament.uk",
    handle: "@ALewerMBE",
  },
  {
    name: "Brandon Lewis",
    party: "Conservative",
    constituency: "Great Yarmouth",
    email: "brandon.lewis.mp@parliament.uk",
    handle: "@BrandonLewis",
  },
  {
    name: "Clive Lewis",
    party: "Labour",
    constituency: "Norwich South",
    email: "clive.lewis.mp@parliament.uk",
    handle: "@labourlewis",
  },
  {
    name: "Sir Julian Lewis",
    party: "Conservative",
    constituency: "New Forest East",
    email: "Julian.Lewis.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mr Ian Liddell-Grainger",
    party: "Conservative",
    constituency: "Bridgwater and West Somerset",
    email: "ianlg@parliament.uk",
    handle: null,
  },
  {
    name: "Simon Lightwood",
    party: "Labour (Co-op)",
    constituency: "Wakefield",
    email: "simon.lightwood.mp@parliament.uk",
    handle: "@simonlightwood",
  },
  {
    name: "David Linden",
    party: "Scottish National Party",
    constituency: "Glasgow East",
    email: "david.linden.mp@parliament.uk",
    handle: "@DavidLinden",
  },
  {
    name: "Tony Lloyd",
    party: "Labour",
    constituency: "Rochdale",
    email: "tony.lloyd.mp@parliament.uk",
    handle: "@tony4rochdale",
  },
  {
    name: "Carla Lockhart",
    party: "Democratic Unionist Party",
    constituency: "Upper Bann",
    email: "carla.lockhart.mp@parliament.uk",
    handle: "@carlalockhart",
  },
  {
    name: "Chris Loder",
    party: "Conservative",
    constituency: "West Dorset",
    email: "chris.loder.mp@parliament.uk",
    handle: "@chrisloder",
  },
  {
    name: "Mark Logan",
    party: "Conservative",
    constituency: "Bolton North East",
    email: "mark.logan.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Rebecca Long Bailey",
    party: "Labour",
    constituency: "Salford and Eccles",
    email: "rebecca.longbailey.mp@parliament.uk",
    handle: "@RLong_Bailey",
  },
  {
    name: "Marco Longhi",
    party: "Conservative",
    constituency: "Dudley North",
    email: "marco.longhi.mp@parliament.uk",
    handle: "@marcolonghi4dn",
  },
  {
    name: "Julia Lopez",
    party: "Conservative",
    constituency: "Hornchurch and Upminster",
    email: "julia.lopez.mp@parliament.uk",
    handle: "@JuliaLopezMP",
  },
  {
    name: "Jack Lopresti",
    party: "Conservative",
    constituency: "Filton and Bradley Stoke",
    email: "jack.lopresti.mp@parliament.uk",
    handle: "@JackLopresti",
  },
  {
    name: "Mr Jonathan Lord",
    party: "Conservative",
    constituency: "Woking",
    email: "jonathan.lord.mp@parliament.uk",
    handle: "@JonathanLord",
  },
  {
    name: "Tim Loughton",
    party: "Conservative",
    constituency: "East Worthing and Shoreham",
    email: "loughtont@parliament.uk",
    handle: "@timloughton",
  },
  {
    name: "Caroline Lucas",
    party: "Green Party",
    constituency: "Brighton, Pavilion",
    email: "caroline.lucas.mp@parliament.uk",
    handle: "@CarolineLucas",
  },
  {
    name: "Holly Lynch",
    party: "Labour",
    constituency: "Halifax",
    email: "holly.lynch.mp@parliament.uk",
    handle: "@HollyLynch5",
  },
  {
    name: "Kenny MacAskill",
    party: "Alba Party",
    constituency: "East Lothian",
    email: "kenny.macaskill.mp@parliament.uk",
    handle: "@KennyMacAskill",
  },
  {
    name: "Steve McCabe",
    party: "Labour",
    constituency: "Birmingham, Selly Oak",
    email: "mccabes@parliament.uk",
    handle: "@steve_mccabe",
  },
  {
    name: "Kerry McCarthy",
    party: "Labour",
    constituency: "Bristol East",
    email: "kerry.mccarthy.mp@parliament.uk",
    handle: "@KerryMP",
  },
  {
    name: "Jason McCartney",
    party: "Conservative",
    constituency: "Colne Valley",
    email: "jason.mccartney.mp@parliament.uk",
    handle: "@JasonMcCartney",
  },
  {
    name: "Karl McCartney",
    party: "Conservative",
    constituency: "Lincoln",
    email: "karl.mccartney.mp@parliament.uk",
    handle: "@karlmccartney",
  },
  {
    name: "Siobhain McDonagh",
    party: "Labour",
    constituency: "Mitcham and Morden",
    email: "mcdonaghs@parliament.uk",
    handle: "@Siobhain_Mc",
  },
  {
    name: "Andy McDonald",
    party: "Labour",
    constituency: "Middlesbrough",
    email: "andy.mcdonald.2nd@parliament.uk",
    handle: "@AndyMcDonaldMP",
  },
  {
    name: "Stewart Malcolm McDonald",
    party: "Scottish National Party",
    constituency: "Glasgow South",
    email: "stewart.mcdonald.mp@parliament.uk",
    handle: "@StewartMcDonald",
  },
  {
    name: "Stuart C McDonald",
    party: "Scottish National Party",
    constituency: "Cumbernauld, Kilsyth and Kirkintilloch East",
    email: "stuart.mcdonald.mp@parliament.uk",
    handle: "@Stuart_McDonald",
  },
  {
    name: "John McDonnell",
    party: "Labour",
    constituency: "Hayes and Harlington",
    email: "mcdonnellj@parliament.uk",
    handle: "@johnmcdonnellMP",
  },
  {
    name: "Pat McFadden",
    party: "Labour",
    constituency: "Wolverhampton South East",
    email: "mcfaddenp@parliament.uk",
    handle: "@patmcfaddenmp",
  },
  {
    name: "Conor McGinn",
    party: "Independent",
    constituency: "St Helens North",
    email: "conor.mcginn.mp@parliament.uk",
    handle: "@ConorMcGinn",
  },
  {
    name: "Alison McGovern",
    party: "Labour",
    constituency: "Wirral South",
    email: "alison.mcgovern.mp@parliament.uk",
    handle: "@Alison_McGovern",
  },
  {
    name: "Craig Mackinlay",
    party: "Conservative",
    constituency: "South Thanet",
    email: "craig.mackinlay.mp@parliament.uk",
    handle: "@cmackinlay",
  },
  {
    name: "Catherine McKinnell",
    party: "Labour",
    constituency: "Newcastle upon Tyne North",
    email: "catherine.mckinnell.mp@parliament.uk",
    handle: "@CatMcKinnell",
  },
  {
    name: "Cherilyn Mackrory",
    party: "Conservative",
    constituency: "Truro and Falmouth",
    email: "cherilyn.mackrory.mp@parliament.uk",
    handle: "@thisischerilyn",
  },
  {
    name: "Anne McLaughlin",
    party: "Scottish National Party",
    constituency: "Glasgow North East",
    email: "anne.mclaughlin.mp@parliament.uk",
    handle: "@AnneMcLaughlin",
  },
  {
    name: "Rachel Maclean",
    party: "Conservative",
    constituency: "Redditch",
    email: "rachel.maclean.mp@parliament.uk",
    handle: "@redditchrachel",
  },
  {
    name: "Jim McMahon",
    party: "Labour (Co-op)",
    constituency: "Oldham West and Royton",
    email: "jim.mcmahon.mp@parliament.uk",
    handle: "@JimfromOldham",
  },
  {
    name: "Anna McMorrin",
    party: "Labour",
    constituency: "Cardiff North",
    email: "anna.mcmorrin.mp@parliament.uk",
    handle: "@AnnaMcMorrin",
  },
  {
    name: "John McNally",
    party: "Scottish National Party",
    constituency: "Falkirk",
    email: "john.mcnally.mp@parliament.uk",
    handle: "@JohnMcNallySNP",
  },
  {
    name: "Angus Brendan MacNeil",
    party: "Scottish National Party",
    constituency: "Na h-Eileanan an Iar",
    email: "macneila@parliament.uk",
    handle: "@AngusMacNeilSNP",
  },
  {
    name: "Stephen McPartland",
    party: "Conservative",
    constituency: "Stevenage",
    email: "stephen@stephenmcpartland.co.uk",
    handle: "@SMcPartland",
  },
  {
    name: "Esther McVey",
    party: "Conservative",
    constituency: "Tatton",
    email: "esther.mcvey.mp@parliament.uk",
    handle: "@EstherMcVey1",
  },
  {
    name: "Justin Madders",
    party: "Labour",
    constituency: "Ellesmere Port and Neston",
    email: "justin.madders.mp@parliament.uk",
    handle: "@justinmadders",
  },
  {
    name: "Mr Khalid Mahmood",
    party: "Labour",
    constituency: "Birmingham, Perry Barr",
    email: "mahmoodk@parliament.uk",
    handle: "@khalid4PB",
  },
  {
    name: "Shabana Mahmood",
    party: "Labour",
    constituency: "Birmingham, Ladywood",
    email: "shabana.mahmood.mp@parliament.uk",
    handle: "@ShabanaMahmood",
  },
  {
    name: "Alan Mak",
    party: "Conservative",
    constituency: "Havant",
    email: "alan.mak.mp@parliament.uk",
    handle: "@AlanMakMP",
  },
  {
    name: "Seema Malhotra",
    party: "Labour (Co-op)",
    constituency: "Feltham and Heston",
    email: "seema.malhotra.mp@parliament.uk",
    handle: "@SeemaMalhotra1",
  },
  {
    name: "Kit Malthouse",
    party: "Conservative",
    constituency: "North West Hampshire",
    email: "kit.malthouse.mp@parliament.uk",
    handle: "@kitmalthouse",
  },
  {
    name: "Anthony Mangnall",
    party: "Conservative",
    constituency: "Totnes",
    email: "anthony.mangnall.mp@parliament.uk",
    handle: "@AnthonyMangnal1",
  },
  {
    name: "Scott Mann",
    party: "Conservative",
    constituency: "North Cornwall",
    email: "scott.mann.mp@parliament.uk",
    handle: "@scottmann4NC",
  },
  {
    name: "Julie Marson",
    party: "Conservative",
    constituency: "Hertford and Stortford",
    email: "julie.marson.mp@parliament.uk",
    handle: "@JulieMarsonMP",
  },
  {
    name: "Rachael Maskell",
    party: "Labour (Co-op)",
    constituency: "York Central",
    email: "rachael.maskell.mp@parliament.uk",
    handle: "@RachaelMaskell",
  },
  {
    name: "Paul Maskey",
    party: "Sinn F\u00e9in",
    constituency: "Belfast West",
    email: "paul.maskey.mp@parliament.uk",
    handle: "@PaulMaskeyMP",
  },
  {
    name: "Mrs Theresa May",
    party: "Conservative",
    constituency: "Maidenhead",
    email: "mayt@parliament.uk",
    handle: "@theresa_may",
  },
  {
    name: "Jerome Mayhew",
    party: "Conservative",
    constituency: "Broadland",
    email: "jerome.mayhew.mp@parliament.uk",
    handle: "@JeromeMayhew",
  },
  {
    name: "Paul Maynard",
    party: "Conservative",
    constituency: "Blackpool North and Cleveleys",
    email: "paul.maynard.mp@parliament.uk",
    handle: "@PaulMaynardUK",
  },
  {
    name: "Ian Mearns",
    party: "Labour",
    constituency: "Gateshead",
    email: "ian.mearns.mp@parliament.uk",
    handle: "@IanMearnsMP",
  },
  {
    name: "Mark Menzies",
    party: "Conservative",
    constituency: "Fylde",
    email: "mark.menzies.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Johnny Mercer",
    party: "Conservative",
    constituency: "Plymouth, Moor View",
    email: "johnny.mercer.mp@parliament.uk",
    handle: "@JohnnyMercerUK",
  },
  {
    name: "Huw Merriman",
    party: "Conservative",
    constituency: "Bexhill and Battle",
    email: "huw.merriman.mp@parliament.uk",
    handle: "@HuwMerriman",
  },
  {
    name: "Stephen Metcalfe",
    party: "Conservative",
    constituency: "South Basildon and East Thurrock",
    email: "stephen.metcalfe.mp@parliament.uk",
    handle: "@Metcalfe_SBET",
  },
  {
    name: "Edward Miliband",
    party: "Labour",
    constituency: "Doncaster North",
    email: "ed.miliband.mp@parliament.uk",
    handle: "@Ed_Miliband",
  },
  {
    name: "Robin Millar",
    party: "Conservative",
    constituency: "Aberconwy",
    email: "robin.millar.mp@parliament.uk",
    handle: "@RobinMillarMP",
  },
  {
    name: "Dame Maria Miller",
    party: "Conservative",
    constituency: "Basingstoke",
    email: "maria.miller.mp@parliament.uk",
    handle: "@MariaMillerUK",
  },
  {
    name: "Amanda Milling",
    party: "Conservative",
    constituency: "Cannock Chase",
    email: "amanda.milling.mp@parliament.uk",
    handle: "@amandamilling",
  },
  {
    name: "Nigel Mills",
    party: "Conservative",
    constituency: "Amber Valley",
    email: "nigel.mills.mp@parliament.uk",
    handle: "@nigelmills",
  },
  {
    name: "Navendu Mishra",
    party: "Labour",
    constituency: "Stockport",
    email: "navendu.mishra.mp@parliament.uk",
    handle: "@NavPMishra",
  },
  {
    name: "Mr Andrew Mitchell",
    party: "Conservative",
    constituency: "Sutton Coldfield",
    email: "andrew.mitchell.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mr Gagan Mohindra",
    party: "Conservative",
    constituency: "South West Hertfordshire",
    email: "gagan.mohindra.mp@parliament.uk",
    handle: "@gaganmohindra",
  },
  {
    name: "Francie Molloy",
    party: "Sinn F\u00e9in",
    constituency: "Mid Ulster",
    email: "francie.molloy.mp@parliament.uk",
    handle: "@FrancieMolloy",
  },
  {
    name: "Carol Monaghan",
    party: "Scottish National Party",
    constituency: "Glasgow North West",
    email: "carol.monaghan.mp@parliament.uk",
    handle: "@CMonaghanSNP",
  },
  {
    name: "Damien Moore",
    party: "Conservative",
    constituency: "Southport",
    email: "damien.moore.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Robbie Moore",
    party: "Conservative",
    constituency: "Keighley",
    email: "robbie.moore.mp@parliament.uk",
    handle: "@_RobbieMoore",
  },
  {
    name: "Layla Moran",
    party: "Liberal Democrat",
    constituency: "Oxford West and Abingdon",
    email: "layla.moran.mp@parliament.uk",
    handle: "@LaylaMoran",
  },
  {
    name: "Penny Mordaunt",
    party: "Conservative",
    constituency: "Portsmouth North",
    email: "penny.mordaunt.mp@parliament.uk",
    handle: "@PennyMordaunt",
  },
  {
    name: "Jessica Morden",
    party: "Labour",
    constituency: "Newport East",
    email: "mordenj@parliament.uk",
    handle: "@jessicamordenmp",
  },
  {
    name: "Helen Morgan",
    party: "Liberal Democrat",
    constituency: "North Shropshire",
    email: "helen.morgan.mp@parliament.uk",
    handle: "@HelenMorganMP",
  },
  {
    name: "Stephen Morgan",
    party: "Labour",
    constituency: "Portsmouth South",
    email: "stephen.morgan.mp@parliament.uk",
    handle: "@StephenMorganMP",
  },
  {
    name: "Anne Marie Morris",
    party: "Conservative",
    constituency: "Newton Abbot",
    email: "annemarie.morris.mp@parliament.uk",
    handle: "@AnneMarieMorris",
  },
  {
    name: "David Morris",
    party: "Conservative",
    constituency: "Morecambe and Lunesdale",
    email: "david.morris.mp@parliament.uk",
    handle: "@davidmorrisml",
  },
  {
    name: "Grahame Morris",
    party: "Labour",
    constituency: "Easington",
    email: "grahame.morris.mp@parliament.uk",
    handle: "@grahamemorris",
  },
  {
    name: "James Morris",
    party: "Conservative",
    constituency: "Halesowen and Rowley Regis",
    email: "james.morris.mp@parliament.uk",
    handle: "@JamesMorris",
  },
  {
    name: "Joy Morrissey",
    party: "Conservative",
    constituency: "Beaconsfield",
    email: "joy.morrissey.mp@parliament.uk",
    handle: "@joymorrissey",
  },
  {
    name: "Jill Mortimer",
    party: "Conservative",
    constituency: "Hartlepool",
    email: "jill.mortimer.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Wendy Morton",
    party: "Conservative",
    constituency: "Aldridge-Brownhills",
    email: "wendy.morton.mp@parliament.uk",
    handle: "@morton_wendy",
  },
  {
    name: "Dr Kieran Mullan",
    party: "Conservative",
    constituency: "Crewe and Nantwich",
    email: "kieran.mullan.mp@parliament.uk",
    handle: "@KieranMullanUK",
  },
  {
    name: "Holly Mumby-Croft",
    party: "Conservative",
    constituency: "Scunthorpe",
    email: "holly.mumbycroft.mp@parliament.uk",
    handle: null,
  },
  {
    name: "David Mundell",
    party: "Conservative",
    constituency: "Dumfriesshire, Clydesdale and Tweeddale",
    email: "david.mundell.mp@parliament.uk",
    handle: "@DavidMundellDCT",
  },
  {
    name: "Ian Murray",
    party: "Labour",
    constituency: "Edinburgh South",
    email: "ian.murray.mp@parliament.uk",
    handle: "@IanMurrayMP",
  },
  {
    name: "James Murray",
    party: "Labour (Co-op)",
    constituency: "Ealing North",
    email: "james.murray.mp@parliament.uk",
    handle: "@jamesmurray_ldn",
  },
  {
    name: "Mrs Sheryll Murray",
    party: "Conservative",
    constituency: "South East Cornwall",
    email: "sheryll.murray.mp@parliament.uk",
    handle: "@sheryllmurray",
  },
  {
    name: "Dr Andrew Murrison",
    party: "Conservative",
    constituency: "South West Wiltshire",
    email: "murrisona@parliament.uk",
    handle: "@AWMurrison",
  },
  {
    name: "Lisa Nandy",
    party: "Labour",
    constituency: "Wigan",
    email: "lisa.nandy.mp@parliament.uk",
    handle: "@lisanandy",
  },
  {
    name: "Sir Robert Neill",
    party: "Conservative",
    constituency: "Bromley and Chislehurst",
    email: "bob.neill.mp@parliament.uk",
    handle: "@neill_bob",
  },
  {
    name: "Gavin Newlands",
    party: "Scottish National Party",
    constituency: "Paisley and Renfrewshire North",
    email: "gavin.newlands.mp@parliament.uk",
    handle: "@GavNewlandsSNP",
  },
  {
    name: "Charlotte Nichols",
    party: "Labour",
    constituency: "Warrington North",
    email: "charlotte.nichols.mp@parliament.uk",
    handle: "@charlotte2153",
  },
  {
    name: "Lia Nici",
    party: "Conservative",
    constituency: "Great Grimsby",
    email: "lia.nici.mp@parliament.uk",
    handle: "@lia_nici",
  },
  {
    name: "John Nicolson",
    party: "Scottish National Party",
    constituency: "Ochil and South Perthshire",
    email: "john.nicolson.mp@parliament.uk",
    handle: "@MrJohnNicolson",
  },
  {
    name: "Caroline Nokes",
    party: "Conservative",
    constituency: "Romsey and Southampton North",
    email: "caroline.nokes.mp@parliament.uk",
    handle: "@carolinenokes",
  },
  {
    name: "Jesse Norman",
    party: "Conservative",
    constituency: "Hereford and South Herefordshire",
    email: "jesse.norman.mp@parliament.uk",
    handle: "@Jesse_Norman",
  },
  {
    name: "Alex Norris",
    party: "Labour (Co-op)",
    constituency: "Nottingham North",
    email: "alex.norris.mp@parliament.uk",
    handle: "@AlexNorrisNN",
  },
  {
    name: "Neil O'Brien",
    party: "Conservative",
    constituency: "Harborough",
    email: "neil.obrien.mp@parliament.uk",
    handle: "@NeilDotObrien",
  },
  {
    name: "Dr Matthew Offord",
    party: "Conservative",
    constituency: "Hendon",
    email: "matthew.offord.mp@parliament.uk",
    handle: "@Offord4Hendon",
  },
  {
    name: "Brendan O'Hara",
    party: "Scottish National Party",
    constituency: "Argyll and Bute",
    email: "brendan.ohara.mp@parliament.uk",
    handle: "@BrendanOHaraMP",
  },
  {
    name: "Sarah Olney",
    party: "Liberal Democrat",
    constituency: "Richmond Park",
    email: "sarah.olney.mp@parliament.uk",
    handle: "@sarahjolney1",
  },
  {
    name: "Chi Onwurah",
    party: "Labour",
    constituency: "Newcastle upon Tyne Central",
    email: "chi.onwurah.mp@parliament.uk",
    handle: "@ChiOnwurah",
  },
  {
    name: "Guy Opperman",
    party: "Conservative",
    constituency: "Hexham",
    email: "guy.opperman@parliament.uk",
    handle: "@GuyOpperman",
  },
  {
    name: "Abena Oppong-Asare",
    party: "Labour",
    constituency: "Erith and Thamesmead",
    email: "abena.oppongasare.mp@parliament.uk",
    handle: "@abenaopp",
  },
  {
    name: "Kate Osamor",
    party: "Labour (Co-op)",
    constituency: "Edmonton",
    email: "kate.osamor.mp@parliament.uk",
    handle: "@KateOsamor",
  },
  {
    name: "Kate Osborne",
    party: "Labour",
    constituency: "Jarrow",
    email: "kate.osborne.mp@parliament.uk",
    handle: "@KateOsborneMP",
  },
  {
    name: "Kirsten Oswald",
    party: "Scottish National Party",
    constituency: "East Renfrewshire",
    email: "kirsten.oswald.mp@parliament.uk",
    handle: "@kirstenoswald",
  },
  {
    name: "Taiwo Owatemi",
    party: "Labour",
    constituency: "Coventry North West",
    email: "taiwo.owatemi.mp@parliament.uk",
    handle: "@TaiwoOwatemi",
  },
  {
    name: "Sarah Owen",
    party: "Labour",
    constituency: "Luton North",
    email: "sarah.owen.mp@parliament.uk",
    handle: "@SarahOwen_",
  },
  {
    name: "Ian Paisley",
    party: "Democratic Unionist Party",
    constituency: "North Antrim",
    email: "ian.paisley.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Priti Patel",
    party: "Conservative",
    constituency: "Witham",
    email: "withammp@parliament.uk",
    handle: "@pritipatel",
  },
  {
    name: "Mark Pawsey",
    party: "Conservative",
    constituency: "Rugby",
    email: "mark.pawsey.mp@parliament.uk",
    handle: "@MarkPawsey",
  },
  {
    name: "Stephanie Peacock",
    party: "Labour",
    constituency: "Barnsley East",
    email: "stephanie.peacock.mp@parliament.uk",
    handle: "@Steph_Peacock",
  },
  {
    name: "Sir Mike Penning",
    party: "Conservative",
    constituency: "Hemel Hempstead",
    email: "mike.penning.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Matthew Pennycook",
    party: "Labour",
    constituency: "Greenwich and Woolwich",
    email: "matthew.pennycook.mp@parliament.uk",
    handle: "@mtpennycook",
  },
  {
    name: "John Penrose",
    party: "Conservative",
    constituency: "Weston-super-Mare",
    email: "teresa.ridley@parliament.uk",
    handle: "@JohnPenroseNews",
  },
  {
    name: "Andrew Percy",
    party: "Conservative",
    constituency: "Brigg and Goole",
    email: "andrew.percy.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mr Toby Perkins",
    party: "Labour",
    constituency: "Chesterfield",
    email: "toby.perkins.mp@parliament.uk",
    handle: "@tobyperkinsmp",
  },
  {
    name: "Jess Phillips",
    party: "Labour",
    constituency: "Birmingham, Yardley",
    email: "jess.phillips.mp@parliament.uk",
    handle: "@jessphillips",
  },
  {
    name: "Bridget Phillipson",
    party: "Labour",
    constituency: "Houghton and Sunderland South",
    email: "bridget.phillipson.mp@parliament.uk",
    handle: "@bphillipsonMP",
  },
  {
    name: "Chris Philp",
    party: "Conservative",
    constituency: "Croydon South",
    email: "chris.philp.mp@parliament.uk",
    handle: "@CPhilpOfficial",
  },
  {
    name: "Sarah Edwards",
    party: "Labour",
    constituency: "Tamworth",
    email: "christopher.pincher.mp@parliament.uk",
    handle: "null",
  },
  {
    name: "Luke Pollard",
    party: "Labour (Co-op)",
    constituency: "Plymouth, Sutton and Devonport",
    email: "luke.pollard.mp@parliament.uk",
    handle: "@LukePollard",
  },
  {
    name: "Dr Dan Poulter",
    party: "Conservative",
    constituency: "Central Suffolk and North Ipswich",
    email: "daniel.poulter.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Rebecca Pow",
    party: "Conservative",
    constituency: "Taunton Deane",
    email: "rebecca.pow.mp@parliament.uk",
    handle: "@pow_rebecca",
  },
  {
    name: "Lucy Powell",
    party: "Labour (Co-op)",
    constituency: "Manchester Central",
    email: "contact@lucypowell.org.uk",
    handle: "@LucyMPowell",
  },
  {
    name: "Victoria Prentis",
    party: "Conservative",
    constituency: "Banbury",
    email: "victoria.prentis.mp@parliament.uk",
    handle: "@VictoriaPrentis",
  },
  {
    name: "Mark Pritchard",
    party: "Conservative",
    constituency: "The Wrekin",
    email: "pritchardm@parliament.uk",
    handle: "@MPritchardUK",
  },
  {
    name: "Tom Pursglove",
    party: "Conservative",
    constituency: "Corby",
    email: "tom.pursglove.mp@parliament.uk",
    handle: "@VotePursglove",
  },
  {
    name: "Ms Anum Qaisar",
    party: "Scottish National Party",
    constituency: "Airdrie and Shotts",
    email: "anum.mp@parliament.uk",
    handle: "@AnumSNP",
  },
  {
    name: "Jeremy Quin",
    party: "Conservative",
    constituency: "Horsham",
    email: "jeremy.quin.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Will Quince",
    party: "Conservative",
    constituency: "Colchester",
    email: "will.quince.mp@parliament.uk",
    handle: "@willquince",
  },
  {
    name: "Yasmin Qureshi",
    party: "Labour",
    constituency: "Bolton South East",
    email: "yasmin.qureshi.mp@parliament.uk",
    handle: "@YasminQureshiMP",
  },
  {
    name: "Dominic Raab",
    party: "Conservative",
    constituency: "Esher and Walton",
    email: "dominic.raab.mp@parliament.uk",
    handle: "@DominicRaab",
  },
  {
    name: "Tom Randall",
    party: "Conservative",
    constituency: "Gedling",
    email: "tom.randall.mp@parliament.uk",
    handle: "@Tom_Randall",
  },
  {
    name: "Angela Rayner",
    party: "Labour",
    constituency: "Ashton-under-Lyne",
    email: "angela.rayner.mp@parliament.uk",
    handle: "@AngelaRayner",
  },
  {
    name: "John Redwood",
    party: "Conservative",
    constituency: "Wokingham",
    email: "john.redwood.mp@parliament.uk",
    handle: "@johnredwood",
  },
  {
    name: "Steve Reed",
    party: "Labour (Co-op)",
    constituency: "Croydon North",
    email: "steve.reed.mp@parliament.uk",
    handle: "@SteveReedMP",
  },
  {
    name: "Christina Rees",
    party: "Independent",
    constituency: "Neath",
    email: "christina.rees.mp@parliament.uk",
    handle: "@Rees4Neath",
  },
  {
    name: "Mr Jacob Rees-Mogg",
    party: "Conservative",
    constituency: "North East Somerset",
    email: "jacob.reesmogg.mp@parliament.uk",
    handle: "@Jacob_Rees_Mogg",
  },
  {
    name: "Ellie Reeves",
    party: "Labour",
    constituency: "Lewisham West and Penge",
    email: "ellie.reeves.mp@parliament.uk",
    handle: "@elliereeves",
  },
  {
    name: "Rachel Reeves",
    party: "Labour",
    constituency: "Leeds West",
    email: "rachel.reeves.mp@parliament.uk",
    handle: "@RachelReevesMP",
  },
  {
    name: "Jonathan Reynolds",
    party: "Labour (Co-op)",
    constituency: "Stalybridge and Hyde",
    email: "jonathan.reynolds.mp@parliament.uk",
    handle: "@jreynoldsMP",
  },
  {
    name: "Bell Ribeiro-Addy",
    party: "Labour",
    constituency: "Streatham",
    email: "bell.ribeiroaddy.mp@parliament.uk",
    handle: "@BellRibeiroAddy",
  },
  {
    name: "Nicola Richards",
    party: "Conservative",
    constituency: "West Bromwich East",
    email: "nicola.richards.mp@parliament.uk",
    handle: "@nicolafrichards",
  },
  {
    name: "Angela Richardson",
    party: "Conservative",
    constituency: "Guildford",
    email: "angela.richardson.mp@parliament.uk",
    handle: "@AJRichardsonMP",
  },
  {
    name: "Ms Marie Rimmer",
    party: "Labour",
    constituency: "St Helens South and Whiston",
    email: "marie.rimmer.mp@parliament.uk",
    handle: "@MarieRimmer",
  },
  {
    name: "Rob Roberts",
    party: "Independent",
    constituency: "Delyn",
    email: "rob.roberts.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mr Laurence Robertson",
    party: "Conservative",
    constituency: "Tewkesbury",
    email: "robertsonl@parliament.uk",
    handle: "@lrobertsonTewks",
  },
  {
    name: "Gavin Robinson",
    party: "Democratic Unionist Party",
    constituency: "Belfast East",
    email: "gavin.robinson.mp@parliament.uk",
    handle: "@GRobinsonDUP",
  },
  {
    name: "Mary Robinson",
    party: "Conservative",
    constituency: "Cheadle",
    email: "mary.robinson.mp@parliament.uk",
    handle: "@MaryRobinson01",
  },
  {
    name: "Matt Rodda",
    party: "Labour",
    constituency: "Reading East",
    email: "matt.rodda.mp@parliament.uk",
    handle: "@MattRodda",
  },
  {
    name: "Andrew Rosindell",
    party: "Conservative",
    constituency: "Romford",
    email: "andrew.rosindell.mp@parliament.uk",
    handle: "@AndrewRosindell",
  },
  {
    name: "Douglas Ross",
    party: "Conservative",
    constituency: "Moray",
    email: "douglas.ross.mp@parliament.uk",
    handle: "@Douglas4Moray",
  },
  {
    name: "Lee Rowley",
    party: "Conservative",
    constituency: "North East Derbyshire",
    email: "lee.rowley.mp@parliament.uk",
    handle: "@Lee4NED",
  },
  {
    name: "Dean Russell",
    party: "Conservative",
    constituency: "Watford",
    email: "dean.russell.mp@parliament.uk",
    handle: "@dean4watford",
  },
  {
    name: "Lloyd Russell-Moyle",
    party: "Labour (Co-op)",
    constituency: "Brighton, Kemptown",
    email: "lloyd.russellmoyle.mp@parliament.uk",
    handle: "@lloyd_rm",
  },
  {
    name: "David Rutley",
    party: "Conservative",
    constituency: "Macclesfield",
    email: "david.rutley.mp@parliament.uk",
    handle: "@DavidRutley",
  },
  {
    name: "Gary Sambrook",
    party: "Conservative",
    constituency: "Birmingham, Northfield",
    email: "gary.sambrook.mp@parliament.uk",
    handle: "@GarySambrook89",
  },
  {
    name: "Liz Saville Roberts",
    party: "Plaid Cymru",
    constituency: "Dwyfor Meirionnydd",
    email: "liz.savilleroberts.mp@parliament.uk",
    handle: "@LSRPlaid",
  },
  {
    name: "Selaine Saxby",
    party: "Conservative",
    constituency: "North Devon",
    email: "selaine.saxby.mp@parliament.uk",
    handle: "@SelaineSaxby",
  },
  {
    name: "Paul Scully",
    party: "Conservative",
    constituency: "Sutton and Cheam",
    email: "paul.scully.mp@parliament.uk",
    handle: "@scullyp",
  },
  {
    name: "Bob Seely",
    party: "Conservative",
    constituency: "Isle of Wight",
    email: "bob.seely.mp@parliament.uk",
    handle: "@IoWBobSeely",
  },
  {
    name: "Andrew Selous",
    party: "Conservative",
    constituency: "South West Bedfordshire",
    email: "andrew.selous.mp@parliament.uk",
    handle: "@AndrewSelous",
  },
  {
    name: "Naz Shah",
    party: "Labour",
    constituency: "Bradford West",
    email: "naz.shah.mp@parliament.uk",
    handle: "@NazShahBfd",
  },
  {
    name: "Jim Shannon",
    party: "Democratic Unionist Party",
    constituency: "Strangford",
    email: "jim.shannon.mp@parliament.uk",
    handle: "@JimShannonMP",
  },
  {
    name: "Grant Shapps",
    party: "Conservative",
    constituency: "Welwyn Hatfield",
    email: "shappsg@parliament.uk",
    handle: "@grantshapps",
  },
  {
    name: "Sir Alok Sharma",
    party: "Conservative",
    constituency: "Reading West",
    email: "alok.sharma.mp@parliament.uk",
    handle: "@AlokSharma_RDG",
  },
  {
    name: "Mr Virendra Sharma",
    party: "Labour",
    constituency: "Ealing, Southall",
    email: "sharmav@parliament.uk",
    handle: "@VirendraSharma",
  },
  {
    name: "Mr Barry Sheerman",
    party: "Labour (Co-op)",
    constituency: "Huddersfield",
    email: "sheermanb@parliament.uk",
    handle: "@BarrySheerman",
  },
  {
    name: "Alec Shelbrooke",
    party: "Conservative",
    constituency: "Elmet and Rothwell",
    email: "alec.shelbrooke.mp@parliament.uk",
    handle: "@AlecShelbrooke",
  },
  {
    name: "Tommy Sheppard",
    party: "Scottish National Party",
    constituency: "Edinburgh East",
    email: "tommy.sheppard.mp@parliament.uk",
    handle: "@TommySheppard",
  },
  {
    name: "Tulip Siddiq",
    party: "Labour",
    constituency: "Hampstead and Kilburn",
    email: "tulip.siddiq.mp@parliament.uk",
    handle: "@TulipSiddiq",
  },
  {
    name: "David Simmonds",
    party: "Conservative",
    constituency: "Ruislip, Northwood and Pinner",
    email: "david.simmonds.mp@parliament.uk",
    handle: "@DSimmonds_RNP",
  },
  {
    name: "Damien Egan",
    party: "Labour",
    constituency: "Kingswood",
    email: "chris.skidmore.mp@parliament.uk",
    handle: "@damienegan",
  },
  {
    name: "Andy Slaughter",
    party: "Labour",
    constituency: "Hammersmith",
    email: "slaughtera@parliament.uk",
    handle: "@hammersmithandy",
  },
  {
    name: "Alyn Smith",
    party: "Scottish National Party",
    constituency: "Stirling",
    email: "alyn.smith.mp@parliament.uk",
    handle: "@AlynSmith",
  },
  {
    name: "Cat Smith",
    party: "Labour",
    constituency: "Lancaster and Fleetwood",
    email: "cat.smith.mp@parliament.uk",
    handle: "@CatSmithMP",
  },
  {
    name: "Chloe Smith",
    party: "Conservative",
    constituency: "Norwich North",
    email: "chloe@chloesmith.org.uk",
    handle: "@NorwichChloe",
  },
  {
    name: "Greg Smith",
    party: "Conservative",
    constituency: "Buckingham",
    email: "greg.smith.mp@parliament.uk",
    handle: "@gregsmith_uk",
  },
  {
    name: "Henry Smith",
    party: "Conservative",
    constituency: "Crawley",
    email: "henry.smith.mp@parliament.uk",
    handle: "@HenrySmithUK",
  },
  {
    name: "Jeff Smith",
    party: "Labour",
    constituency: "Manchester, Withington",
    email: "jeff.smith.mp@parliament.uk",
    handle: "@JeffSmithetc",
  },
  {
    name: "Julian Smith",
    party: "Conservative",
    constituency: "Skipton and Ripon",
    email: "julian.smith.mp@parliament.uk",
    handle: "@JulianSmithUK",
  },
  {
    name: "Nick Smith",
    party: "Labour",
    constituency: "Blaenau Gwent",
    email: "nick.smith.mp@parliament.uk",
    handle: "@BlaenauGwentMP",
  },
  {
    name: "Royston Smith",
    party: "Conservative",
    constituency: "Southampton, Itchen",
    email: "royston.smith.mp@parliament.uk",
    handle: "@Royston_Smith",
  },
  {
    name: "Karin Smyth",
    party: "Labour",
    constituency: "Bristol South",
    email: "karin.smyth.mp@parliament.uk",
    handle: "@karinsmyth",
  },
  {
    name: "Alex Sobel",
    party: "Labour (Co-op)",
    constituency: "Leeds North West",
    email: "alex.sobel.mp@parliament.uk",
    handle: "@alexsobel",
  },
  {
    name: "Amanda Solloway",
    party: "Conservative",
    constituency: "Derby North",
    email: "amanda.solloway.mp@parliament.uk",
    handle: "@ASollowayUK",
  },
  {
    name: "John Spellar",
    party: "Labour",
    constituency: "Warley",
    email: "john.spellar.mp@parliament.uk",
    handle: "@spellar",
  },
  {
    name: "Dr Ben Spencer",
    party: "Conservative",
    constituency: "Runnymede and Weybridge",
    email: "ben.spencer.mp@parliament.uk",
    handle: "@DrBenSpencer",
  },
  {
    name: "Mark Spencer",
    party: "Conservative",
    constituency: "Sherwood",
    email: "mark.spencer.mp@parliament.uk",
    handle: "@Mark_Spencer",
  },
  {
    name: "Alexander Stafford",
    party: "Conservative",
    constituency: "Rother Valley",
    email: "alexander.stafford.mp@parliament.uk",
    handle: "@Alex_Stafford",
  },
  {
    name: "Keir Starmer",
    party: "Labour",
    constituency: "Holborn and St Pancras",
    email: "keir.starmer.mp@parliament.uk",
    handle: "@Keir_Starmer",
  },
  {
    name: "Chris Stephens",
    party: "Scottish National Party",
    constituency: "Glasgow South West",
    email: "chris.stephens.mp@parliament.uk",
    handle: "@ChrisStephens",
  },
  {
    name: "Andrew Stephenson",
    party: "Conservative",
    constituency: "Pendle",
    email: "andrew.stephenson.mp@parliament.uk",
    handle: "@Andrew4Pendle",
  },
  {
    name: "Jo Stevens",
    party: "Labour",
    constituency: "Cardiff Central",
    email: "jo.stevens.mp@parliament.uk",
    handle: "@JoStevensLabour",
  },
  {
    name: "Jane Stevenson",
    party: "Conservative",
    constituency: "Wolverhampton North East",
    email: "jane.stevenson.mp@parliament.uk",
    handle: "@Jane_Stevenson_",
  },
  {
    name: "John Stevenson",
    party: "Conservative",
    constituency: "Carlisle",
    email: "office@johnstevensonmp.co.uk",
    handle: "@John4Carlisle",
  },
  {
    name: "Bob Stewart",
    party: "Conservative",
    constituency: "Beckenham",
    email: "bob.stewart.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Iain Stewart",
    party: "Conservative",
    constituency: "Milton Keynes South",
    email: "iain.stewart.mp@parliament.uk",
    handle: "@iainastewart",
  },
  {
    name: "Jamie Stone",
    party: "Liberal Democrat",
    constituency: "Caithness, Sutherland and Easter Ross",
    email: "jamie.stone.mp@parliament.uk",
    handle: "@Jamie4North",
  },
  {
    name: "Sir Gary Streeter",
    party: "Conservative",
    constituency: "South West Devon",
    email: "deans@parliament.uk",
    handle: "@garystreeterSWD",
  },
  {
    name: "Wes Streeting",
    party: "Labour",
    constituency: "Ilford North",
    email: "wes.streeting.mp@parliament.uk",
    handle: "@wesstreeting",
  },
  {
    name: "Mel Stride",
    party: "Conservative",
    constituency: "Central Devon",
    email: "mel.stride.mp@parliament.uk",
    handle: "@MelJStride",
  },
  {
    name: "Graham Stringer",
    party: "Labour",
    constituency: "Blackley and Broughton",
    email: "graham.stringer.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Graham Stuart",
    party: "Conservative",
    constituency: "Beverley and Holderness",
    email: "grahamstuartmp@parliament.uk",
    handle: "@grahamstuart",
  },
  {
    name: "Julian Sturdy",
    party: "Conservative",
    constituency: "York Outer",
    email: "julian.sturdy.mp@parliament.uk",
    handle: "@JulianSturdy",
  },
  {
    name: "Zarah Sultana",
    party: "Labour",
    constituency: "Coventry South",
    email: "zarah.sultana.mp@parliament.uk",
    handle: "@zarahsultana",
  },
  {
    name: "Rishi Sunak",
    party: "Conservative",
    constituency: "Richmond (Yorks)",
    email: "rishi.sunak.mp@parliament.uk",
    handle: "@RishiSunak",
  },
  {
    name: "James Sunderland",
    party: "Conservative",
    constituency: "Bracknell",
    email: "james.sunderland.mp@parliament.uk",
    handle: "@JamesSunderl",
  },
  {
    name: "Sir Desmond Swayne",
    party: "Conservative",
    constituency: "New Forest West",
    email: "swayned@parliament.uk",
    handle: "@DesmondSwayne",
  },
  {
    name: "Sir Robert Syms",
    party: "Conservative",
    constituency: "Poole",
    email: "symsmp.office@parliament.uk",
    handle: "@RobertSyms",
  },
  {
    name: "Mark Tami",
    party: "Labour",
    constituency: "Alyn and Deeside",
    email: "tamim@parliament.uk",
    handle: "@MarkTamiMP",
  },
  {
    name: "Sam Tarry",
    party: "Labour",
    constituency: "Ilford South",
    email: "sam.tarry.mp@parliament.uk",
    handle: "@SamTarry",
  },
  {
    name: "Alison Thewliss",
    party: "Scottish National Party",
    constituency: "Glasgow Central",
    email: "alison.thewliss.mp@parliament.uk",
    handle: "@alisonthewliss",
  },
  {
    name: "Derek Thomas",
    party: "Conservative",
    constituency: "St Ives",
    email: "derek.thomas.mp@parliament.uk",
    handle: "@DerekThomasUK",
  },
  {
    name: "Gareth Thomas",
    party: "Labour (Co-op)",
    constituency: "Harrow West",
    email: "gareth.thomas.mp@parliament.uk",
    handle: "@GarethThomasMP",
  },
  {
    name: "Nick Thomas-Symonds",
    party: "Labour",
    constituency: "Torfaen",
    email: "nick.thomassymonds.mp@parliament.uk",
    handle: "@NickTorfaen",
  },
  {
    name: "Owen Thompson",
    party: "Scottish National Party",
    constituency: "Midlothian",
    email: "owen.thompson.mp@parliament.uk",
    handle: "@OwenThompson",
  },
  {
    name: "Richard Thomson",
    party: "Scottish National Party",
    constituency: "Gordon",
    email: "richard.thomson.mp@parliament.uk",
    handle: "@RThomsonMP",
  },
  {
    name: "Emily Thornberry",
    party: "Labour",
    constituency: "Islington South and Finsbury",
    email: "thornberrye@parliament.uk",
    handle: "@EmilyThornberry",
  },
  {
    name: "Maggie Throup",
    party: "Conservative",
    constituency: "Erewash",
    email: "maggie.throup.mp@parliament.uk",
    handle: "@maggie_erewash",
  },
  {
    name: "Sir Stephen Timms",
    party: "Labour",
    constituency: "East Ham",
    email: "timmss@parliament.uk",
    handle: "@stephenctimms",
  },
  {
    name: "Edward Timpson",
    party: "Conservative",
    constituency: "Eddisbury",
    email: "edward.timpson.mp@parliament.uk",
    handle: "@edwardtimpson",
  },
  {
    name: "Kelly Tolhurst",
    party: "Conservative",
    constituency: "Rochester and Strood",
    email: "kelly.tolhurst.mp@parliament.uk",
    handle: "@KellyTolhurst",
  },
  {
    name: "Justin Tomlinson",
    party: "Conservative",
    constituency: "North Swindon",
    email: "justin.tomlinson.mp@parliament.uk",
    handle: "@JustinTomlinson",
  },
  {
    name: "Michael Tomlinson",
    party: "Conservative",
    constituency: "Mid Dorset and North Poole",
    email: "michael.tomlinson.mp@parliament.uk",
    handle: "@Michael4MDNP",
  },
  {
    name: "Craig Tracey",
    party: "Conservative",
    constituency: "North Warwickshire",
    email: "craig.tracey.mp@parliament.uk",
    handle: "@craig4nwarks",
  },
  {
    name: "Anne-Marie Trevelyan",
    party: "Conservative",
    constituency: "Berwick-upon-Tweed",
    email: "annemarie.trevelyan.mp@parliament.uk",
    handle: "@annietrev",
  },
  {
    name: "Jon Trickett",
    party: "Labour",
    constituency: "Hemsworth",
    email: "trickettj@parliament.uk",
    handle: "@jon_trickett",
  },
  {
    name: "Laura Trott",
    party: "Conservative",
    constituency: "Sevenoaks",
    email: "laura.trott.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Elizabeth Truss",
    party: "Conservative",
    constituency: "South West Norfolk",
    email: "elizabeth.truss.mp@parliament.uk",
    handle: "@trussliz",
  },
  {
    name: "Tom Tugendhat",
    party: "Conservative",
    constituency: "Tonbridge and Malling",
    email: "tom.tugendhat.mp@parliament.uk",
    handle: "@TomTugendhat",
  },
  {
    name: "Karl Turner",
    party: "Labour",
    constituency: "Kingston upon Hull East",
    email: "karl.turner.mp@parliament.uk",
    handle: "@KarlTurnerMP",
  },
  {
    name: "Derek Twigg",
    party: "Labour",
    constituency: "Halton",
    email: "derek.twigg.mp@parliament.uk",
    handle: "@DerekTwiggMP",
  },
  {
    name: "Liz Twist",
    party: "Labour",
    constituency: "Blaydon",
    email: "liz.twist.mp@parliament.uk",
    handle: "@LizTwistMP",
  },
  {
    name: "Shailesh Vara",
    party: "Conservative",
    constituency: "North West Cambridgeshire",
    email: "shailesh.vara.mp@parliament.uk",
    handle: "@ShaileshVara",
  },
  {
    name: "Valerie Vaz",
    party: "Labour",
    constituency: "Walsall South",
    email: "valerie.vaz.mp@parliament.uk",
    handle: "@Valerie_VazMP",
  },
  {
    name: "Martin Vickers",
    party: "Conservative",
    constituency: "Cleethorpes",
    email: "martin.vickers.mp@parliament.uk",
    handle: "@MartinVickers",
  },
  {
    name: "Matt Vickers",
    party: "Conservative",
    constituency: "Stockton South",
    email: "matt.vickers.mp@parliament.uk",
    handle: "@Matt_VickersMP",
  },
  {
    name: "Theresa Villiers",
    party: "Conservative",
    constituency: "Chipping Barnet",
    email: "theresa@theresavilliers.co.uk",
    handle: null,
  },
  {
    name: "Christian Wakeford",
    party: "Labour",
    constituency: "Bury South",
    email: "christian.wakeford.mp@parliament.uk",
    handle: "@Christian4BuryS",
  },
  {
    name: "Sir Charles Walker",
    party: "Conservative",
    constituency: "Broxbourne",
    email: "charles.walker.mp@parliament.uk",
    handle: "@CharlesWalkerMP",
  },
  {
    name: "Mr Robin Walker",
    party: "Conservative",
    constituency: "Worcester",
    email: "robin.walker.mp@parliament.uk",
    handle: "@WalkerWorcester",
  },
  {
    name: "Mr Ben Wallace",
    party: "Conservative",
    constituency: "Wyre and Preston North",
    email: "wallaceb@parliament.uk",
    handle: "@BWallaceMP",
  },
  {
    name: "Dr Jamie Wallis",
    party: "Conservative",
    constituency: "Bridgend",
    email: "jamie.wallis.mp@parliament.uk",
    handle: "@JamieWallisMP",
  },
  {
    name: "David Warburton",
    party: "Independent",
    constituency: "Somerton and Frome",
    email: "david.warburton.mp@parliament.uk",
    handle: "@DJWarburton",
  },
  {
    name: "Matt Warman",
    party: "Conservative",
    constituency: "Boston and Skegness",
    email: "matt.warman.mp@parliament.uk",
    handle: "@mattwarman",
  },
  {
    name: "Giles Watling",
    party: "Conservative",
    constituency: "Clacton",
    email: "giles.watling.mp@parliament.uk",
    handle: "@GilesWatling",
  },
  {
    name: "Suzanne Webb",
    party: "Conservative",
    constituency: "Stourbridge",
    email: "suzanne.webb.mp@parliament.uk",
    handle: "@Q66Suzi",
  },
  {
    name: "Claudia Webbe",
    party: "Independent",
    constituency: "Leicester East",
    email: "claudia.webbe.mp@parliament.uk",
    handle: "@ClaudiaWebbe",
  },
  {
    name: "Catherine West",
    party: "Labour",
    constituency: "Hornsey and Wood Green",
    email: "catherine.west.mp@parliament.uk",
    handle: "@CatherineWest1",
  },
  {
    name: "Andrew Western",
    party: "Labour",
    constituency: "Stretford and Urmston",
    email: "andrew.western.mp@parliament.uk",
    handle: "@AndrewHWestern",
  },
  {
    name: "Matt Western",
    party: "Labour",
    constituency: "Warwick and Leamington",
    email: "matt.western.mp@parliament.uk",
    handle: "@MattWestern_",
  },
  {
    name: "Helen Whately",
    party: "Conservative",
    constituency: "Faversham and Mid Kent",
    email: "helen.whately.mp@parliament.uk",
    handle: "@Helen_Whately",
  },
  {
    name: "Mrs Heather Wheeler",
    party: "Conservative",
    constituency: "South Derbyshire",
    email: "heather.wheeler.mp@parliament.uk",
    handle: "@HeatherWheeler",
  },
  {
    name: "Dr Alan Whitehead",
    party: "Labour",
    constituency: "Southampton, Test",
    email: "whiteheada@parliament.uk",
    handle: "@alanwhiteheadmp",
  },
  {
    name: "Dr Philippa Whitford",
    party: "Scottish National Party",
    constituency: "Central Ayrshire",
    email: "philippa.whitford.mp@parliament.uk",
    handle: "@Dr_PhilippaW",
  },
  {
    name: "Mick Whitley",
    party: "Labour",
    constituency: "Birkenhead",
    email: "mick.whitley.mp@parliament.uk",
    handle: "@MickWhitleyMP",
  },
  {
    name: "Craig Whittaker",
    party: "Conservative",
    constituency: "Calder Valley",
    email: "craig.whittaker.mp@parliament.uk",
    handle: "@CWhittaker_MP",
  },
  {
    name: "Sir John Whittingdale",
    party: "Conservative",
    constituency: "Maldon",
    email: "john.whittingdale.mp@parliament.uk",
    handle: "@JWhittingdale",
  },
  {
    name: "Nadia Whittome",
    party: "Labour",
    constituency: "Nottingham East",
    email: "nadia.whittome.mp@parliament.uk",
    handle: "@NadiaWhittomeMP",
  },
  {
    name: "Sir Bill Wiggin",
    party: "Conservative",
    constituency: "North Herefordshire",
    email: "bill.wiggin.mp@parliament.uk",
    handle: null,
  },
  {
    name: "James Wild",
    party: "Conservative",
    constituency: "North West Norfolk",
    email: "james.wild.mp@parliament.uk",
    handle: "@jamesowild",
  },
  {
    name: "Craig Williams",
    party: "Conservative",
    constituency: "Montgomeryshire",
    email: "craig.williams.mp@parliament.uk",
    handle: "@craig4monty",
  },
  {
    name: "Hywel Williams",
    party: "Plaid Cymru",
    constituency: "Arfon",
    email: "hywel.williams.mp@parliament.uk",
    handle: "@HywelPlaidCymru",
  },
  {
    name: "Sir Gavin Williamson",
    party: "Conservative",
    constituency: "South Staffordshire",
    email: "gavin.williamson.mp@parliament.uk",
    handle: "@GavinWilliamson",
  },
  {
    name: "Munira Wilson",
    party: "Liberal Democrat",
    constituency: "Twickenham",
    email: "munira.wilson.mp@parliament.uk",
    handle: "@munirawilson",
  },
  {
    name: "Sammy Wilson",
    party: "Democratic Unionist Party",
    constituency: "East Antrim",
    email: "barronj@parliament.uk",
    handle: "@eastantrimmp",
  },
  {
    name: "Beth Winter",
    party: "Labour",
    constituency: "Cynon Valley",
    email: "beth.winter.mp@parliament.uk",
    handle: "@BethWinterMP",
  },
  {
    name: "Dame Rosie Winterton",
    party: "Labour",
    constituency: "Doncaster Central",
    email: "rosie.winterton.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Pete Wishart",
    party: "Scottish National Party",
    constituency: "Perth and North Perthshire",
    email: "pete.wishart.mp@parliament.uk",
    handle: "@PeteWishart",
  },
  {
    name: "Mike Wood",
    party: "Conservative",
    constituency: "Dudley South",
    email: "mike.wood.mp@parliament.uk",
    handle: "@mikejwood",
  },
  {
    name: "Mr William Wragg",
    party: "Conservative",
    constituency: "Hazel Grove",
    email: "william@williamwragg.org.uk",
    handle: "@William_Wragg",
  },
  {
    name: "Sir Jeremy Wright",
    party: "Conservative",
    constituency: "Kenilworth and Southam",
    email: "Jeremy.wright.mp@parliament.uk",
    handle: null,
  },
  {
    name: "Mohammad Yasin",
    party: "Labour",
    constituency: "Bedford",
    email: "mohammad.yasin.mp@parliament.uk",
    handle: "@YasinForBedford",
  },
  {
    name: "Jacob Young",
    party: "Conservative",
    constituency: "Redcar",
    email: "jacob.young.mp@parliament.uk",
    handle: "@JacobYoungMP",
  },
  {
    name: "Nadhim Zahawi",
    party: "Conservative",
    constituency: "Stratford-on-Avon",
    email: "nadhim.zahawi.mp@parliament.uk",
    handle: "@nadhimzahawi",
  },
  {
    name: "Daniel Zeichner",
    party: "Labour",
    constituency: "Cambridge",
    email: "daniel@danielzeichner.co.uk",
    handle: "@DanielZeichner",
  },
];
